export const customerSupportJson = {
  uid: "248f9ac4-729b-4713-845a-797e1b4acb65",
  componentName: "CustomerSupport",
  dataSource: "{19453B22-22AE-4D55-8F39-8C8F341FA873}",
  params: {
    buttonAlignment: "center",
    variant: "base",
    numberOfColumns: "three",
    backgroundColor: "orange-white",
    paddingTop: "Medium",
    paddingBottom: "Medium",
  },
  fields: {
    supportIcon: {
      id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
      fieldType: "Droplink",
      fieldName: "supportIcon",
      url: "/sitecore/content/fwd/global/settings/list/linkvariant/call",
      fields: { value: { value: "call" }, key: { value: "Call" } },
    },
    title: { value: "Find out more" },
    description: {
      value:
        "Can’t decide which product is right for you? Want to get more information? Select from the options below.",
    },
    supportOptions: [
      {
        id: "48391c1c-5699-4669-ba3b-7492f9401e2f",
        fields: {
          contactNumber: { value: "+852 3123 3123" },
          subTitle: { value: "We’re here to help from Monday to Friday, 9am-6pm, and Saturday, 9am-1pm." },
          icon: {
            value: {
              src: "/-/media/images/supports/call.svg?rev=5ed85ebbe95342b3972b09a5f8f8b3ac",
              alt: "call",
            },
          },
          title: { value: "Call customer support" },
          supportIcon: {
            id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
            fieldType: "CustomDroplink",
            fieldName: "supportIcon",
            url: "/sitecore/content/fwd/global/settings/list/linkvariant/call",
            fields: {
              value: { value: "call" },
              key: { value: "Call" },
            },
          },
          buttonIcon: {
            id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
            fieldType: "CustomDroplink",
            fieldName: "buttonIcon",
            url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
            fields: {
              value: { value: "arrow-right" },
              key: { value: "Link" },
            },
          },
          link: {
            value: {
              href: "http://tel:+852 3123 3123",
              text: "Call 3123 3123",
              linktype: "external",
              url: "http://tel:+852 3123 3123",
              anchor: "",
              target: "",
            },
          },
          buttonMode: {
            id: "02a5a5c7-c318-4919-b773-86a65ba98969",
            fieldType: "Droplink",
            fieldName: "buttonMode",
            url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
            fields: {
              value: { value: "SimpleLink" },
              key: { value: "SimpleLink" },
            },
          },
          linkGALabelName: { value: "Call 3123 3123" },
          listType: {
            id: "a5bee68c-8e43-4f78-8d15-d42982fd053a",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "/sitecore/content/fwd/global/settings/list/linklisttype/call",
            fields: {
              value: { value: "Call" },
              key: { value: "call" },
            },
          },
        },
      },

      {
        id: "b947c809-c632-4013-b6ed-24446509484c",
        fields: {
          medalliaForm: { value: "" },
          title: { value: "Leave a message" },
          icon: {
            value: {
              src: "/-/media/images/supports/call.svg?rev=5ed85ebbe95342b3972b09a5f8f8b3ac",
              alt: "call",
            },
          },
          subTitle: {
            value:
              "Send us your enquiries, or any feedback. We’ll get back to you shortly.",
          },
          supportIcon: {
            id: "f35ed9fd-ad24-494a-8fb6-33be8955a85d",
            fieldType: "CustomDroplink",
            fieldName: "supportIcon",
            url: "/sitecore/content/fwd/global/settings/list/linkvariant/call-email",
            fields: {
              value: { value: "call-email" },
              key: { value: "callEmail" },
            },
          },
          listType: {
            id: "f281af72-fa4b-4f87-98f1-4b9d77180e60",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "/sitecore/content/fwd/global/settings/list/linklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          buttonIcon: {
            id: "f35ed9fd-ad24-494a-8fb6-33be8955a85d",
            fieldType: "CustomDroplink",
            fieldName: "buttonIcon",
            url: "/sitecore/content/fwd/global/settings/list/linkvariant/call-email",
            fields: {
              value: { value: "call-email" },
              key: { value: "callEmail" },
            },
          },
          link: {
            value: {
              text: "Enquire",
              linktype: "form",
              anchor: "enquiry",
              querystring: "enquiry",
              title: "enquiry",
              target: "",
              id: "{F2728281-FA5C-41CB-B168-773E0C78197F}",
              href: "/forms-list/product-enquiry-form",
            },
          },
          buttonMode: {
            id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
            fieldType: "Droplink",
            fieldName: "buttonMode",
            url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
            fields: {
              value: { value: "Primary" },
              key: { value: "Primary" },
            },
          },
          linkGALabelName: { value: "Product Enquiry" },
        },
      },
    ],
    buttonIcon: null,
    link: {
      value: {
        href: "https://www.fwd.com.hk/en/support/",
        text: "Show me all support options",
        anchor: "",
        linktype: "internal",
        class: "",
        title: "",
        querystring: "",
        id: "{9C6D9E13-7967-40EA-AAAA-753CA0685D6C}",
      },
    },
    buttonMode: {
      id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
      fieldType: "Droplink",
      fieldName: "buttonMode",
      url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
      fields: {
        value: { value: "Primary" },
        key: { value: "Primary" },
      },
    },
    linkGALabelName: { value: "" },
    gaLabelName: { value: "" },
    gaCategoryName: { value: "" },
  },
  callbackForm: {
    sitecoreContext: {
      pageEditing: false,
      site: { name: "fwd-hk" },
      pageState: "normal",
      language: "en",
      languageCode: "en",
      defaultLanguage: "zh-HK",
      siteSettings: {
        productListPage: "/products/",
        splashPage: "",
        articleTagLink: "/search/",
        articleTypeDesign: [],
        articleOverlineText: false,
        globalMetaText: "FWD HK",
        globalMetaTag: "",
        cookieMessage:
          '<p>We use cookies to give you the best possible experience on our website. By continuing to browse this site, you give consent for cookies to be used. </p>\n<p>For more details please read our <a href="~/link.aspx?_id=DCD61657FA884252B0580B7EBE7F06F1&amp;_z=z">Cookie Policy</a>.</p>',
        cookieTimeStamp: "10",
        currencyPlacement: "BeforeNumericals",
        currencyWhitespace: false,
        currencySeparator: { value: {} },
        currencyLabel: { value: { USD: "US$", EUR: "EUR", HKD: "HK$" } },
        splashPageUpdatedDuration: "10",
        splashPageUpdatedDate: "",
        faviconImageUrl:
          "/-/media/global/images/icons/favicon.ico?rev=51cce1bfcfb347b3b2fc7d304180401d",
        productErrorPictogramUrl:
          "/-/media/pictograms/no-result-48px2x.png?rev=6b3f1e7975b545d780c8a676eb165ef0",
        dateFormat: "D MMMM YYYY",
        enablePlanCardSharePostCalc: "",
        sessionTimeout: "20",
        loaderTimeout: "20",
        gAID: "GTM-N6B3G67",
        gTMID: "GTM-N6B3G67",
        gtmParamters: [],
        optimize360: true,
        hostName: "https://www.fwd.com.hk",
        enableBackToTopButton: 1,
        dialogSessionTimeout: "20",
        productFallbackCTA: {
          value: {
            href: "/forms-list/product-enquiry-form",
            text: "Enquire",
            anchor: "Enquire",
            linkType: "form",
            title: "Enquire",
            queryString: "enquiry",
            id: "{F2728281-FA5C-41CB-B168-773E0C78197F}",
            gaLabel: "Enquiry",
          },
        },
        brightcoveAccountID: "5650355171001",
        languageIcon: { key: "language-globe", value: "language-globe" },
        enableMultipleNotifications: true,
        hidePrimaryLanguage: true,
        currencyGALabelName: "",
        showArticleSubtitle: false,
        hasArticleSubtitleFallback: false,
      },
      share: {
        socialApps: [
          {
            facebook: {
              url: {
                value: {
                  href: "https://www.facebook.com/sharer.php?u=",
                  text: "Facebook Url",
                  linktype: "external",
                  url: "https://www.facebook.com/sharer.php?u=",
                  anchor: "",
                  target: "",
                },
              },
              header: { value: "Share on Facebook" },
              toolTip: { value: "" },
            },
          },
          {
            Whatsapp: {
              url: {
                value: {
                  href: "https://web.whatsapp.com/send?text=",
                  linktype: "external",
                  url: "https://web.whatsapp.com/send?text=",
                  anchor: "",
                  target: "",
                },
              },
              header: { value: "Share on Whatsapp" },
              toolTip: { value: "" },
            },
          },
          {
            Linkedin: {
              url: {
                value: {
                  href: "https://www.linkedin.com/sharing/share-offsite/?url=",
                  linktype: "external",
                  url: "https://www.linkedin.com/sharing/share-offsite/?url=",
                  anchor: "",
                  target: "",
                },
              },
              header: { value: "Share on Linkedin" },
              toolTip: { value: "" },
            },
          },
        ],
      },
      siteNotifications: {
        notifications: [
          {
            hidePublishDate: { value: true },
            publishDate: "2022-08-18T04:08:00Z",
            description: {
              value:
                '<span style="color: #273d35;">FWD launched &lsquo;Free Special Benefit Against Vaccination Complications&rsquo;.&nbsp;</span>Please click <a href="https://www.fwd.com.hk/en/coronavirusfaq">here</a>&nbsp;for details.',
            },
            expiryDate: "2024-03-30T03:30:00Z",
            pagesList: { value: "/" },
            icon: {
              id: "c0c57154-6ec6-4264-8d86-a4efebbd1533",
              fieldType: "CustomDroplink",
              fieldName: "icon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/notification---obsolete",
              fields: {
                value: { value: "notification-icon" },
                key: { value: "Notification" },
              },
            },
          },
          {
            hidePublishDate: { value: true },
            publishDate: "2022-08-03T04:14:00Z",
            description: {
              value:
                "<p>COVID-19 NOTICE: Our FWD Insurance Solutions Centres (ISC) are providing service from 9:30am to 5:30pm from Monday to Saturday, and closed on Sunday and public holidays. Our customer hotline provides service from 9am to 6pm daily.</p>",
            },
            expiryDate: "2025-11-08T01:00:00Z",
            pagesList: { value: "/,/business/" },
            icon: {
              id: "c4ce9c6d-80fa-402f-9b49-87c412a21684",
              fieldType: "CustomDroplink",
              fieldName: "icon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/alert---obsolete",
              fields: { value: { value: "alert" }, key: { value: "alert" } },
            },
          },
          {
            hidePublishDate: { value: true },
            publishDate: "2022-02-22T08:06:00Z",
            description: {
              value:
                'This website (<a href="https://www.fwd.com.hk/en/claims">https://fwd.com.hk/en/claims</a>) is operated by FWD Financial Limited, an appointed and licensed insurance agent of FWD Life Insurance Company (Bermuda) Limited and FWD General Insurance Company Limited.',
            },
            expiryDate: "2030-02-22T00:00:00Z",
            pagesList: { value: "/claims/" },
          },
          {
            hidePublishDate: { value: true },
            publishDate: "2022-02-22T08:06:00Z",
            description: {
              value:
                'This website (<a href="https://www.fwd.com.hk/en/products">https://fwd.com.hk/en/products</a>) is operated by FWD Financial Limited, an appointed and licensed insurance agent of FWD Life Insurance Company (Bermuda) Limited and FWD General Insurance Company Limited.',
            },
            expiryDate: "2030-02-22T00:00:00Z",
            pagesList: { value: "/products/" },
          },
          {
            hidePublishDate: { value: true },
            publishDate: "2022-02-22T08:06:00Z",
            description: {
              value:
                'This website (<a href="https://www.fwd.com.hk/en/support/">https://fwd.com.hk/en/support</a>) is operated by FWD Financial Limited, an appointed and licensed insurance agent of FWD Life Insurance Company (Bermuda) Limited and FWD General Insurance Company Limited.',
            },
            expiryDate: "2030-02-22T00:00:00Z",
            pagesList: { value: "/support/" },
          },
          {
            hidePublishDate: { value: true },
            publishDate: "2022-02-24T03:04:00Z",
            description: {
              value:
                "This website (https://fwd.com.hk) is operated by FWD Life Insurance Company (Bermuda) Limited.",
            },
            expiryDate: "2025-11-08T01:00:00Z",
            pagesList: { value: "/, /business/" },
            icon: {
              id: "c4ce9c6d-80fa-402f-9b49-87c412a21684",
              fieldType: "CustomDroplink",
              fieldName: "icon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/alert---obsolete",
              fields: { value: { value: "alert" }, key: { value: "alert" } },
            },
          },
        ],
      },
      dialogModals: {
        modalList: [
          {
            activeSessionModal: {
              title: { value: "Are you still here?" },
              description: {
                value:
                  "This page will expire in {time} seconds. You've been inactive for some time. Select continue to stay on page.",
              },
              key: {
                id: "bab3dabc-242d-419f-bc41-f342458cb50a",
                fieldType: "Droplink",
                fieldName: "key",
                url: "/sitecore/content/fwd/global/settings/list/dialog-modal/activesessionmodal",
                fields: {
                  value: { value: "ActiveSessionModal" },
                  key: { value: "activeSessionModal" },
                },
              },
              buttonIcon: {
                id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                fields: {
                  value: { value: "arrow-right" },
                  key: { value: "Link" },
                },
              },
              link: { value: {} },
              buttonMode: {
                id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                fieldType: "Droplink",
                fieldName: "buttonMode",
                url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                fields: {
                  value: { value: "SimpleLink" },
                  key: { value: "SimpleLink" },
                },
              },
              linkGALabelName: { value: "" },
              secondaryLinkButtonMode: {
                id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                fieldType: "Droplink",
                fieldName: "secondaryLinkButtonMode",
                url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                fields: {
                  value: { value: "Secondary" },
                  key: { value: "Secondary" },
                },
              },
              secondaryLinkGALabelName: { value: "" },
              secondaryLink: { value: {} },
              secondaryLinkButtonIcon: {
                id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                fieldType: "CustomDroplink",
                fieldName: "secondaryLinkButtonIcon",
                url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                fields: {
                  value: { value: "arrow-right" },
                  key: { value: "Link" },
                },
              },
            },
          },
          {
            expiredSessionModal: {
              title: { value: "The page has expired" },
              description: {
                value:
                  "It looks like you've been inactive for some time. Your information hasn't been stored. Please refresh and try again.",
              },
              key: {
                id: "13bd5030-db40-4148-a65f-678b8f0fb5a5",
                fieldType: "Droplink",
                fieldName: "key",
                url: "/sitecore/content/fwd/global/settings/list/dialog-modal/expiredsessionmodal",
                fields: {
                  value: { value: "ExpiredSessionModal" },
                  key: { value: "expiredSessionModal" },
                },
              },
              buttonIcon: {
                id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                fields: {
                  value: { value: "arrow-right" },
                  key: { value: "Link" },
                },
              },
              link: { value: {} },
              buttonMode: {
                id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                fieldType: "Droplink",
                fieldName: "buttonMode",
                url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                fields: {
                  value: { value: "Primary" },
                  key: { value: "Primary" },
                },
              },
              linkGALabelName: { value: "" },
              secondaryLinkButtonMode: {
                id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                fieldType: "Droplink",
                fieldName: "secondaryLinkButtonMode",
                url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                fields: {
                  value: { value: "Secondary" },
                  key: { value: "Secondary" },
                },
              },
              secondaryLinkGALabelName: { value: "" },
              secondaryLink: { value: {} },
              secondaryLinkButtonIcon: {
                id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                fieldType: "CustomDroplink",
                fieldName: "secondaryLinkButtonIcon",
                url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                fields: {
                  value: { value: "arrow-right" },
                  key: { value: "Link" },
                },
              },
            },
          },
        ],
      },
      disclosurePopups: {
        popupList: [
          {
            title: { value: "Risk Disclosure Statements" },
            footerText: { value: "" },
            text: {
              value:
                '<div style="display: none;">&nbsp;</div>\n<p style="text-align: center;">(Applicable to Investment-linked Assurance Schemes only)\n</p>\n<ul>\n    <li>The following investment choices are available for the investment-linked assurance schemes ("ILAS") issued by FWD Insurance Company (Bermuda) Limited<span style="color: #183028;">(incorporated in Bermuda with limited liability)</span>("FWD"). Your investments are subject to the credit risks of FWD.</li>\n</ul>\n<ul>\n    <li><span style="color: #183028;">Although your ILAS is a life insurance policy, because your death benefit is linked to the performance of the investment choice you selected from time to time, your death benefit is subject to investment risks and market fluctuations. The death benefit payable may be significantly less than your premiums paid and may not be sufficient for your individual needs.</span></li>\n</ul>\n<ul>\n    <li><span style="color: #183028;">The premiums paid by you towards the ILAS, and any investments made by FWD in the underlying funds corresponding to the investment choices you selected, will become and remain part of the assets of FWD. You do not have any rights or ownership over these underlying investments. Your recourse is against FWD only.</span></li>\n</ul>\n<ul>\n    <li>The premiums paid by you will be invested by FWD into the underlying funds corresponding to the investment choices as selected by you for FWD&rsquo;s asset liability management. However, the unit(s) allocated to your policy account is notional and is solely for the purpose of determining the account value and benefits under your policy.</li>\n</ul>\n<ul>\n    <li><span style="color: #183028;">Your return on investment is calculated by FWD with reference to the performance of the underlying funds.&nbsp; Besides, your return shall be subject to ongoing fees and charges which will continue to be deducted from the ILAS, hence, it may be lower than the return of the corresponding underlying funds. Each of the underlying funds has its own investment profile and associated risks. Underlying funds corresponding to the investment choices available for selection are listed in the investment choices brochure. These underlying funds are authorized by the SFC pursuant to the Code on Unit Trusts and Mutual Funds. Please note that SFC authorization is not a recommendation or endorsement of a scheme nor does it guarantee the commercial merits of a scheme or its performance. It does not mean the scheme is suitable for all investors nor is it an endorsement of its suitability for any particular investors or class of investors.</span></li>\n</ul>\n<ul>\n    <li><span style="color: #183028;">Early termination, surrender or withdrawal of the account value of the ILAS may result in significant loss of your investment and principal paid as well as bonuses awarded (if applicable). Poor performance of the underlying funds may further magnify your investment losses while all charges are still deductible. Besides, FWD may effect termination of your ILAS if your policy is held by an incorporation which is a non-participating Foreign Financial Institutions in respect of U.S. Foreign Account Tax Compliance Act.</span></li>\n</ul>\n<ul>\n    <li>The investment choices available under ILAS can have very different features and risk profiles. Some may be of high risk.The underlying funds of some investment choices is/ are derivative fund with net derivative exposure exceeding 50% of its net asset value. It may only be suitable for investors who understand the complicated structure of derivative product and associated risk. You may incur significant loss if investing in such investment choices. You are strongly advised to exercise caution in relation to such investment choice(s).</li>\n</ul>\n<ul>\n    <li>You should not purchase this product unless you understand it and it has been explained to you how it is suitable for you. The final decision is yours.</li>\n</ul>\n<ul>\n    <li><span style="color: #183028;">Investment choice(s) which denoted the names ended with (&ldquo;Dis&rdquo;) (collectively, the &ldquo;Investment Choices (Cash Distribution)&rdquo;) are linked to the share class of the underlying funds that aim to pay dividend regularly. Investment Choices (Cash Distribution) may distribute cash dividend. If you choose to invest in such investment choice(s), you will receive cash dividend if FWD receive such dividend from the underlying fund(s) of the investment choice(s). However, please note that:</span><span style="color: #183028;">&nbsp;</span>\n    <ol style="list-style-type: lower-roman;">\n        <li><span style="color: #183028;">the corresponding underlying fund of the respective Investment Choices (Cash Distribution) may at its discretion effectively pay dividend out of the capital of the underlying fund (i.e. gross income while charging/ paying all or part of the underlying fund&rsquo;s fees and expenses to/ out of the capital of the underlying fund, resulting in an increase in distributable income for the payment of dividends by the underlying fund).</span><span style="color: #183028;"></span></li>\n        <li><span style="color: #183028;">payment of dividends out of capital by the corresponding underlying fund amounts to a return or withdrawal of part of an investor&rsquo;s original investment or from any capital gains attributable to that original investment. </span></li>\n        <li><span style="color: #183028;">any distributions involving payment of dividends out of capital may result in an immediate reduction of the net asset value per unit of the underlying fund, which may have a negative impact on the price of the Investment Choice (Cash Distribution). This may in turn reduce and result in a deduction to the account value of your policy. In this case, death benefit, surrender benefit and maturity benefit will be reduced.</span> </li>\n        <li><span style="color: #183028;">It is not guaranteed that the underlying fund of an Investment Choice (Cash Distribution) will distribute cash dividend or distribute a fixed amount of cash dividend or distribute cash dividend at a periodic frequency. The amount of cash dividend paid is in no way an indication, a forecast or a projection of cash dividends to be paid in the future.</span></li>\n    </ol>\n    </li>\n</ul>\n<div style="text-align: left;"><strong><span style="color: #183028;">Investment involves risks. For details and charges of ILAS, please refer to the offering documents of ILAS and the underlying funds.</span></strong></div>\n<p style="text-align: left;"><strong>Investment involves risks. Past performance should not be taken as an indication of future performance. You should not invest based on this material alone. You should read ILAS offering documents for details including the risk factors.</strong><br />\n<strong></strong></p>\n<div style="text-align: left;"><strong>\n<br />\nIssued by<br />\nFWD Life Insurance Company (Bermuda) Limited&nbsp;<strong><span style="color: #183028;">(incorporated in Bermuda with limited liability)</span></strong></strong></div>',
            },
            sticky: { value: true },
            activeAtEndOfScroll: { value: true },
            isRiskDisclosure: { value: true },
            defaultPageLink: {
              value: {
                href: "https://www.fwd.com.hk/en/products/",
                text: "",
                anchor: "",
                linktype: "internal",
                class: "",
                title: "",
                querystring: "",
                id: "{DB3FF0BC-2E10-4735-8BAA-76A87A906821}",
              },
            },
            sessionTimeout: { value: "1" },
            enableSmallView: { value: false },
            frequency: {
              id: "8342b7fa-a8ba-4fd5-b7ca-fea9248e4f42",
              fieldType: "Droplink",
              fieldName: "frequency",
              url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/once-in-browsing-session",
              fields: {
                value: { value: "Once in browsing session" },
                key: { value: "once-in-browsing-session" },
              },
            },
            buttonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "buttonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            link: {
              value: {
                href: "https://www.fwd.com.hk/en/products/invest/",
                text: "YES, I’ve read and understand the above information.",
                anchor: "",
                linktype: "internal",
                class: "",
                title: "",
                target: "",
                querystring: "",
                id: "{2375DA5B-104B-4B0C-A915-78223732320F}",
              },
            },
            buttonMode: {
              id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
              fieldType: "Droplink",
              fieldName: "buttonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
              fields: {
                value: { value: "Primary" },
                key: { value: "Primary" },
              },
            },
            linkGALabelName: { value: "" },
            closeCTALabel: { value: "" },
            isCloseCTA: { value: false },
            secondaryLinkButtonMode: {
              id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
              fieldType: "Droplink",
              fieldName: "secondaryLinkButtonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
              fields: {
                value: { value: "Secondary" },
                key: { value: "Secondary" },
              },
            },
            secondaryLinkGALabelName: { value: "" },
            secondaryLink: { value: {} },
            secondaryLinkButtonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "secondaryLinkButtonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            secondaryCloseCTALabel: { value: "NO, I don’t want to continue" },
            isSecondaryCloseCTA: { value: true },
            FormParameters: { value: {} },
            IsFormPost: { value: false },
            id: "a502d7b5-56e5-49ee-af75-d767bb290981",
          },
          {
            title: { value: "" },
            footerText: { value: "" },
            text: {
              value:
                "The MPF products distributed by FWD are now provided by Sun Life. You will be redirected to the website of the respective MPF Scheme Administrator for checking your MPF account.",
            },
            sticky: { value: true },
            activeAtEndOfScroll: { value: true },
            isRiskDisclosure: { value: false },
            defaultPageLink: {
              value: {
                href: "https://www.fwd.com.hk/en/",
                text: "",
                anchor: "",
                linktype: "internal",
                class: "",
                title: "",
                querystring: "",
                id: "{9CB72689-FA18-4900-B876-3AE397D3B009}",
              },
            },
            sessionTimeout: { value: "10" },
            enableSmallView: { value: false },
            frequency: {
              id: "8342b7fa-a8ba-4fd5-b7ca-fea9248e4f42",
              fieldType: "Droplink",
              fieldName: "frequency",
              url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/once-in-browsing-session",
              fields: {
                value: { value: "Once in browsing session" },
                key: { value: "once-in-browsing-session" },
              },
            },
            buttonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "buttonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            link: {
              value: {
                href: "https://cs01.cspension.com.hk/fwdweb/",
                text: "Visit",
                linktype: "external",
                url: "https://cs01.cspension.com.hk/fwdweb/",
                anchor: "",
                target: "_blank",
              },
            },
            buttonMode: {
              id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
              fieldType: "Droplink",
              fieldName: "buttonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
              fields: {
                value: { value: "Primary" },
                key: { value: "Primary" },
              },
            },
            linkGALabelName: { value: "" },
            closeCTALabel: { value: "" },
            isCloseCTA: { value: false },
            secondaryLinkButtonMode: {
              id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
              fieldType: "Droplink",
              fieldName: "secondaryLinkButtonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
              fields: {
                value: { value: "Secondary" },
                key: { value: "Secondary" },
              },
            },
            secondaryLinkGALabelName: { value: "" },
            secondaryLink: { value: {} },
            secondaryLinkButtonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "secondaryLinkButtonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            secondaryCloseCTALabel: { value: "" },
            isSecondaryCloseCTA: { value: false },
            FormParameters: { value: {} },
            IsFormPost: { value: false },
            id: "d6037e42-3522-4edd-8cd8-f814f3528e6b",
          },
          {
            title: { value: "" },
            footerText: { value: "" },
            text: {
              value:
                '<p>FWD and Sun Life have entered into a strategic relationship for Hong Kong Retirement Services</p>\n<p>With effect from 3 October, 2017, the sponsor of FWD MPF Schemes has been changed to Sun Life Hong Kong Limited (&ldquo;Sun Life&rdquo;) and the FWD MPF Master Trust Basic / Comprehensive Schemes have been changed to Sun Life MPF Basic / Comprehensive Scheme.</p>\n<p>FWD Life Insurance Company (Bermuda) Limited (&ldquo;FWD&rdquo;) and Sun Life have also entered into a 15-year strategic distribution agreement allowing FWD&rsquo;s tied agency to distribute Sun Life&rsquo;s MPF products in the Hong Kong market.</p>\n<p>For further information on Sun Life&rsquo;s MPF schemes, please click "visit" to Sun Life Hong Kong&rsquo;s homepage and the Customer Corner where you can log on to the Online Pension Services Centre. For enquiries about the related MPF scheme, please call (852) 3183 1900.</p>\n<p>The investments mentioned in this website may not be suitable to all investors. The information contained in this website is provided for reference only and does not constitute any investment advice. Investors are advised to seek independent advice before making any investment decision.</p>\n<p>Investment involves risk and investors may not get back the amount originally invested. Past performance is not indicative of future performance. Please read the relevant offering document carefully, in particular fund features and risks factors.</p>\n<p>FWD is regulated by the SFC. Non-Hong Kong residents are responsible for observing all applicable laws and regulations of their relevant jurisdictions before proceeding to access the information contained herein.</p>\n<div>&nbsp;</div>',
            },
            sticky: { value: true },
            activeAtEndOfScroll: { value: true },
            isRiskDisclosure: { value: false },
            defaultPageLink: {
              value: {
                href: "https://www.fwd.com.hk/en/products/invest/orso/",
                text: "",
                anchor: "",
                linktype: "internal",
                class: "",
                title: "",
                target: "",
                querystring: "",
                id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
              },
            },
            sessionTimeout: { value: "10" },
            enableSmallView: { value: false },
            frequency: {
              id: "0585858d-6024-4df6-a556-08bc04932510",
              fieldType: "Droplink",
              fieldName: "frequency",
              url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
              fields: {
                value: { value: "Every time user land on the identified page" },
                key: { value: "every-time-in-session" },
              },
            },
            buttonIcon: null,
            link: {
              value: {
                href: "https://www.sunlife.com.hk/en/investments/mpf-orso-fund-prices-performance/?vgnLocale=zh_en",
                text: "Visit",
                linktype: "external",
                url: "https://www.sunlife.com.hk/en/investments/mpf-orso-fund-prices-performance/?vgnLocale=zh_en",
                anchor: "",
                target: "",
              },
            },
            buttonMode: {
              id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
              fieldType: "Droplink",
              fieldName: "buttonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
              fields: {
                value: { value: "Primary" },
                key: { value: "Primary" },
              },
            },
            linkGALabelName: { value: "" },
            closeCTALabel: { value: "" },
            isCloseCTA: { value: false },
            secondaryLinkButtonMode: {
              id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
              fieldType: "Droplink",
              fieldName: "secondaryLinkButtonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
              fields: {
                value: { value: "Primary" },
                key: { value: "Primary" },
              },
            },
            secondaryLinkGALabelName: { value: "" },
            secondaryLink: {
              value: {
                href: "https://www.fwd.com.hk/en/products/invest/orso/",
                text: "Close",
                anchor: "",
                linktype: "internal",
                class: "",
                title: "",
                target: "",
                querystring: "",
                id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
              },
            },
            secondaryLinkButtonIcon: null,
            secondaryCloseCTALabel: { value: "" },
            isSecondaryCloseCTA: { value: true },
            FormParameters: { value: {} },
            IsFormPost: { value: false },
            id: "6907d3f8-481b-419c-b333-a1a0f654b773",
          },
          {
            title: { value: "" },
            footerText: { value: "" },
            text: {
              value:
                '<p><strong>IMPORTANT</strong></p>\n<ul>\n    <li>FWD Multi-Funding Provident Plan (the "Plan") is a pooled retirement scheme established by an insurance policy issued by FWD Life Insurance Company (Bermuda) Limited ("FWD Life").</li>\n    <li>The guarantee of the FWD Capital Guarantee Fund is provided by FWD Life. Your investments in FWD Capital Guarantee Fund are therefore subject to the credit risks of FWD Life. The guarantee is subject to qualifying conditions as set out in Appendix 1 to the Explanatory Memorandum in respect of the FWD Capital Guarantee Fund.</li>\n    <li>Each of the Managed Funds of the Scheme will invest in the corresponding Underlying Funds. Such Underlying Funds may invest in equities, debt securities and/or financial derivative instruments, as the case may be, each with a different risk profile.</li>\n    <li>Underlying Funds which invest in emerging markets may be subject to higher liquidity and volatility risks. Underlying Funds which invest in a particular market or sector may be subject to a higher concentration risk than funds with a more diversified investment policy.</li>\n    <li>Underlying Funds which invest in debt securities that are low-rated or non-investment grade debt securities may be subject to higher credit and counterparty risks than funds which invest in debt securities with higher credit ratings.</li>\n    <li>Underlying Funds which invest substantially in financial derivative instruments may be subject to significant liquidity and counterparty default risks and therefore may expose the Underlying Funds to the potential for significant losses.</li>\n    <li>The Scheme is constituted in the form of an insurance policy. While the benefit payments under the Scheme are calculated with reference to the performance of the Investment Options, you are not investing in the underlying investment funds / assets and do not have any rights or ownership over the underlying investment funds / assets.&nbsp; Such underlying investment funds / assets are legally owned by FWD Life.&nbsp; You only have a contractual right to claim the amount representing the benefits under the Scheme from FWD Life.&nbsp; Your investment in the Scheme is therefore subject to the credit risks of FWD Life.</li>\n    <li>You should consider your own risk tolerance level and financial circumstances before making any investment choices. If you are in doubt as to whether a Managed Fund is suitable for you (including whether it is consistent with your investment objectives), you should seek independent financial and/or professional advice.</li>\n    <li>You should not invest based on this website alone. You should read this Explanatory Memorandum for further details including product features, fees and charges and risk factors (set out in section 3 headed "INVESTMENT RISKS AND RISK FACTORS").</li>\n</ul>\n<p><strong>Important Notes:</strong></p>\n<ul>\n    <li>The Plan has been authorized by the Securities and Futures Commission ("SFC"). Such authorization does not imply any official recommendation by the SFC.</li>\n    <li>Investment involves risk and past performance information presented is not indicative of future performance. Not all investment choice available under the Plan would be suitable for everyone. There is no assurance on investment returns and your investments/accrued benefits may suffer significant losses.</li>\n    <li>For further details including the features of the Plan, please refer to the details in the Explanatory Memorandum. Please refer to the latest offering documents of the underlying funds. If you are in doubt about the meaning or effect of the contents of the Explanatory Memorandum and the offering document of each underlying fund, you should seek professional advice.</li>\n</ul>\n<p>Issued by FWD Life Insurance Company (Bermuda) Limited.</p>\n<p><strong>IMPORTANT INFORMATION</strong></p>\n<p>PLEASE READ CAREFULLY AND CLICK THE <strong>ACCEPT</strong> BUTTON TO CONTINUE.</p>\n<p>Information contained in this web site is provided "AS IS" and "AS AVAILABLE". The Company does not warrant the adequacy of these information and materials. No warranty of any kind, implied, express or statutory, including but not limited to the copyright, title, merchantability, fitness for a particular purpose and freedom from computer virus, is given in conjunction with the information and materials.</p>\n<p>Information is current as at the date of publication but is subject to change without notice.</p>\n<p>Registration with, or approval or authorization by the Mandatory Provident Fund Schemes Authority and the Securities and Futures Commission does not imply official recommendation.</p>\n<p>Investment involves risk and the prices of units may go down as well as up. Past performance figures shown are not indicative of future returns. Please refer to the relevant Explanatory Memorandum/Offering Document for further details.</p>',
            },
            sticky: { value: true },
            activeAtEndOfScroll: { value: false },
            isRiskDisclosure: { value: false },
            defaultPageLink: {
              value: {
                href: "https://www.fwd.com.hk/en/products/invest/orso/",
                text: "",
                anchor: "",
                linktype: "internal",
                class: "",
                title: "",
                querystring: "",
                id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
              },
            },
            sessionTimeout: { value: "2" },
            enableSmallView: { value: false },
            frequency: {
              id: "0585858d-6024-4df6-a556-08bc04932510",
              fieldType: "Droplink",
              fieldName: "frequency",
              url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
              fields: {
                value: { value: "Every time user land on the identified page" },
                key: { value: "every-time-in-session" },
              },
            },
            buttonIcon: null,
            link: {
              value: {
                href: "https://www.fwd.com.hk/en/products/invest/orso/fund-performance/",
                text: "Accept",
                anchor: "",
                linktype: "internal",
                class: "",
                title: "",
                target: "",
                querystring: "",
                id: "{08204FFD-2104-462A-9271-72552A3B5491}",
              },
            },
            buttonMode: {
              id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
              fieldType: "Droplink",
              fieldName: "buttonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
              fields: {
                value: { value: "Primary" },
                key: { value: "Primary" },
              },
            },
            linkGALabelName: { value: "" },
            closeCTALabel: { value: "" },
            isCloseCTA: { value: false },
            secondaryLinkButtonMode: {
              id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
              fieldType: "Droplink",
              fieldName: "secondaryLinkButtonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
              fields: {
                value: { value: "Primary" },
                key: { value: "Primary" },
              },
            },
            secondaryLinkGALabelName: { value: "" },
            secondaryLink: {
              value: {
                href: "https://www.fwd.com.hk/en/products/invest/orso/",
                text: "Not Accept",
                anchor: "",
                linktype: "internal",
                class: "",
                title: "",
                target: "",
                querystring: "",
                id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
              },
            },
            secondaryLinkButtonIcon: null,
            secondaryCloseCTALabel: { value: "" },
            isSecondaryCloseCTA: { value: true },
            FormParameters: { value: {} },
            IsFormPost: { value: false },
            id: "a87c6d76-dac0-4e31-b731-fd439a9d247b",
          },
          {
            title: { value: "Before you leave our website" },
            footerText: { value: "" },
            text: {
              value:
                'This link will bring you to another website that is not operated by FWD Life. FWD Life is not responsible in any way for the information provided on any other website.<br />\n<br />\nProviding this link does not mean that FWD Life endorses or guarantees anything about the operators of that website, or about the information, products, or services provided by them.<br />\n<br />\nI confirm that I have read, understood and accepted FWD Life&rsquo;s <a href="/404?item=web%3a%7bE10372DB-B865-433F-B3FE-C0F40018E4AA%7d%40en">Personal Information Collection Statement (&ldquo;PICS&rdquo;) </a>and agreed to be bound by the same.<br />\n<br />\nPlease note that if you click on the link and enter the other website, you will be subject to the terms of use and privacy policies of that other website.<br />\n<div>&nbsp;</div>\n<br />',
            },
            sticky: { value: true },
            activeAtEndOfScroll: { value: false },
            isRiskDisclosure: { value: false },
            defaultPageLink: { value: {} },
            sessionTimeout: { value: "" },
            enableSmallView: { value: false },
            frequency: {
              id: "0585858d-6024-4df6-a556-08bc04932510",
              fieldType: "Droplink",
              fieldName: "frequency",
              url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
              fields: {
                value: { value: "Every time user land on the identified page" },
                key: { value: "every-time-in-session" },
              },
            },
            buttonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "buttonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            link: {
              value: {
                href: "https://wa.me/85265320781",
                text: "Confirm and continue",
                linktype: "external",
                url: "https://wa.me/85265320781",
                anchor: "",
                target: "_blank",
              },
            },
            buttonMode: {
              id: "02a5a5c7-c318-4919-b773-86a65ba98969",
              fieldType: "Droplink",
              fieldName: "buttonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
              fields: {
                value: { value: "SimpleLink" },
                key: { value: "SimpleLink" },
              },
            },
            linkGALabelName: { value: "" },
            closeCTALabel: { value: "" },
            isCloseCTA: { value: false },
            secondaryLinkButtonMode: {
              id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
              fieldType: "Droplink",
              fieldName: "secondaryLinkButtonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
              fields: {
                value: { value: "Secondary" },
                key: { value: "Secondary" },
              },
            },
            secondaryLinkGALabelName: { value: "" },
            secondaryLink: { value: {} },
            secondaryLinkButtonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "secondaryLinkButtonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            secondaryCloseCTALabel: { value: "Back" },
            isSecondaryCloseCTA: { value: true },
            FormParameters: { value: {} },
            IsFormPost: { value: false },
            id: "9393cb81-8d91-4cda-a494-70ab242c70a4",
          },
          {
            title: {
              value: "You are being redirected to the website of bolttech",
            },
            footerText: { value: "" },
            text: {
              value:
                'Such redirection does not constitute endorsement, approval, warranty or representation, express or implied, by FWD Life Insurance Company (Bermuda) Limited (incorporated in Bermuda with limited liability) ("FWD Life") of bolttech or the hypertext link, product, service or information contained or available in bolttech&rsquo;s website. FWD Life is not in any way responsible for the contents available in the linked bolttech&rsquo;s website and shall not be responsible for any damage or losses incurred or suffered by you arising out of or in connection with your use of the link.',
            },
            sticky: { value: true },
            activeAtEndOfScroll: { value: true },
            isRiskDisclosure: { value: true },
            defaultPageLink: {
              value: {
                href: "/fwd/fwd-hk/Home/Products/car-boat/motor-smart-plus",
                linktype: "external",
                url: "/fwd/fwd-hk/Home/Products/car-boat/motor-smart-plus",
                anchor: "",
                target: "",
              },
            },
            sessionTimeout: { value: "1" },
            enableSmallView: { value: false },
            frequency: {
              id: "0585858d-6024-4df6-a556-08bc04932510",
              fieldType: "Droplink",
              fieldName: "frequency",
              url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
              fields: {
                value: { value: "Every time user land on the identified page" },
                key: { value: "every-time-in-session" },
              },
            },
            buttonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "buttonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            link: {
              value: {
                href: "https://www.fwdgi.hk/en/car-insurance?pc=FMSPO10&utm_source=ifwd&utm_medium=referral&utm_content=buynowbutton",
                text: "Agree and continue",
                linktype: "external",
                url: "https://www.fwdgi.hk/en/car-insurance?pc=FMSPO10&utm_source=ifwd&utm_medium=referral&utm_content=buynowbutton",
                anchor: "",
                target: "",
              },
            },
            buttonMode: {
              id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
              fieldType: "Droplink",
              fieldName: "buttonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
              fields: {
                value: { value: "Primary" },
                key: { value: "Primary" },
              },
            },
            linkGALabelName: { value: "" },
            closeCTALabel: { value: "" },
            isCloseCTA: { value: false },
            secondaryLinkButtonMode: {
              id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
              fieldType: "Droplink",
              fieldName: "secondaryLinkButtonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
              fields: {
                value: { value: "Secondary" },
                key: { value: "Secondary" },
              },
            },
            secondaryLinkGALabelName: { value: "" },
            secondaryLink: { value: {} },
            secondaryLinkButtonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "secondaryLinkButtonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            secondaryCloseCTALabel: { value: "" },
            isSecondaryCloseCTA: { value: false },
            FormParameters: { value: {} },
            IsFormPost: { value: false },
            id: "5ff33e21-1230-4247-8dfe-ae59221944fa",
          },
          {
            title: {
              value:
                "You are being redirected to the website of FWD General Insurance Company Limited (“FWD GI”), a Bolttech company",
            },
            footerText: { value: "" },
            text: {
              value:
                'Such redirection does not constitute endorsement, approval, warranty or representation, express or implied, by FWD Life Insurance Company (Bermuda) Limited (incorporated in Bermuda with limited liability) ("FWD Life") of FWD GI or the hypertext link, product, service or information contained or available in FWD GI&rsquo;s website. FWD Life is not in any way responsible for the contents available in the linked FWD GI&rsquo;s website and shall not be responsible for any damage or losses incurred or suffered by you arising out of or in connection with your use of the link.',
            },
            sticky: { value: true },
            activeAtEndOfScroll: { value: true },
            isRiskDisclosure: { value: true },
            defaultPageLink: {
              value: {
                href: "/fwd/fwd-hk/Home/Products/helper/helper-care-insurance",
                linktype: "external",
                url: "/fwd/fwd-hk/Home/Products/helper/helper-care-insurance",
                anchor: "",
                target: "",
              },
            },
            sessionTimeout: { value: "1" },
            enableSmallView: { value: false },
            frequency: {
              id: "0585858d-6024-4df6-a556-08bc04932510",
              fieldType: "Droplink",
              fieldName: "frequency",
              url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
              fields: {
                value: { value: "Every time user land on the identified page" },
                key: { value: "every-time-in-session" },
              },
            },
            buttonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "buttonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            link: {
              value: {
                href: "https://www.fwdgi.hk/en/domestic-helper-insurance?utm_source=ifwd&utm_content=buynowbutton&pc=HELPER10",
                text: "Agree and continue",
                linktype: "external",
                url: "https://www.fwdgi.hk/en/domestic-helper-insurance?utm_source=ifwd&utm_content=buynowbutton&pc=HELPER10",
                anchor: "",
                target: "",
              },
            },
            buttonMode: {
              id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
              fieldType: "Droplink",
              fieldName: "buttonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
              fields: {
                value: { value: "Primary" },
                key: { value: "Primary" },
              },
            },
            linkGALabelName: { value: "" },
            closeCTALabel: { value: "" },
            isCloseCTA: { value: false },
            secondaryLinkButtonMode: {
              id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
              fieldType: "Droplink",
              fieldName: "secondaryLinkButtonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
              fields: {
                value: { value: "Secondary" },
                key: { value: "Secondary" },
              },
            },
            secondaryLinkGALabelName: { value: "" },
            secondaryLink: { value: {} },
            secondaryLinkButtonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "secondaryLinkButtonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            secondaryCloseCTALabel: { value: "" },
            isSecondaryCloseCTA: { value: false },
            FormParameters: { value: {} },
            IsFormPost: { value: false },
            id: "0a84b12a-2810-414e-a01c-ffc8f28b71c0",
          },
          {
            title: {
              value:
                "You are being redirected to the website of FWD General Insurance Company Limited (“FWD GI”), a Bolttech company",
            },
            footerText: { value: "" },
            text: {
              value:
                'Such redirection does not constitute endorsement, approval, warranty or representation, express or implied, by FWD Life Insurance Company (Bermuda) Limited (incorporated in Bermuda with limited liability) ("FWD Life") of FWD GI or the hypertext link, product, service or information contained or available in FWD GI&rsquo;s website. FWD Life is not in any way responsible for the contents available in the linked FWD GI&rsquo;s website and shall not be responsible for any damage or losses incurred or suffered by you arising out of or in connection with your use of the link.',
            },
            sticky: { value: true },
            activeAtEndOfScroll: { value: true },
            isRiskDisclosure: { value: true },
            defaultPageLink: {
              value: {
                href: "/fwd/fwd-hk/Home/Products/household-pets/home-care-insurance/",
                linktype: "external",
                url: "/fwd/fwd-hk/Home/Products/household-pets/home-care-insurance/",
                anchor: "",
                target: "",
              },
            },
            sessionTimeout: { value: "1" },
            enableSmallView: { value: false },
            frequency: {
              id: "0585858d-6024-4df6-a556-08bc04932510",
              fieldType: "Droplink",
              fieldName: "frequency",
              url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
              fields: {
                value: { value: "Every time user land on the identified page" },
                key: { value: "every-time-in-session" },
              },
            },
            buttonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "buttonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            link: {
              value: {
                href: "https://www.fwdgi.hk/en/home-care-insurance?utm_source=ifwd&utm_content=buynowbutton&&pc=HOMEC10",
                text: "Agree and continue",
                linktype: "external",
                url: "https://www.fwdgi.hk/en/home-care-insurance?utm_source=ifwd&utm_content=buynowbutton&&pc=HOMEC10",
                anchor: "",
                target: "",
              },
            },
            buttonMode: {
              id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
              fieldType: "Droplink",
              fieldName: "buttonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
              fields: {
                value: { value: "Primary" },
                key: { value: "Primary" },
              },
            },
            linkGALabelName: { value: "" },
            closeCTALabel: { value: "" },
            isCloseCTA: { value: false },
            secondaryLinkButtonMode: {
              id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
              fieldType: "Droplink",
              fieldName: "secondaryLinkButtonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
              fields: {
                value: { value: "Secondary" },
                key: { value: "Secondary" },
              },
            },
            secondaryLinkGALabelName: { value: "" },
            secondaryLink: { value: {} },
            secondaryLinkButtonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "secondaryLinkButtonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            secondaryCloseCTALabel: { value: "" },
            isSecondaryCloseCTA: { value: false },
            FormParameters: { value: {} },
            IsFormPost: { value: false },
            id: "1af378f3-ec18-4f13-90aa-37c28070087d",
          },
          {
            title: {
              value:
                "You are being redirected to the website of FWD General Insurance Company Limited (“FWD GI”), a Bolttech company",
            },
            footerText: { value: "" },
            text: {
              value:
                'Such redirection does not constitute endorsement, approval, warranty or representation, express or implied, by FWD Life Insurance Company (Bermuda) Limited (incorporated in Bermuda with limited liability) ("FWD Life") of FWD GI or the hypertext link, product, service or information contained or available in FWD GI&rsquo;s website. FWD Life is not in any way responsible for the contents available in the linked FWD GI&rsquo;s website and shall not be responsible for any damage or losses incurred or suffered by you arising out of or in connection with your use of the link.',
            },
            sticky: { value: true },
            activeAtEndOfScroll: { value: true },
            isRiskDisclosure: { value: true },
            defaultPageLink: {
              value: {
                href: "https://www.fwd.com.hk/en/products/household-pets/easy-home-care/",
                text: "",
                anchor: "",
                linktype: "internal",
                class: "",
                title: "",
                target: "",
                querystring: "",
                id: "{4C2582F3-9667-4957-B3F9-53C8056EBA7F}",
              },
            },
            sessionTimeout: { value: "1" },
            enableSmallView: { value: false },
            frequency: {
              id: "0585858d-6024-4df6-a556-08bc04932510",
              fieldType: "Droplink",
              fieldName: "frequency",
              url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
              fields: {
                value: { value: "Every time user land on the identified page" },
                key: { value: "every-time-in-session" },
              },
            },
            buttonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "buttonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            link: {
              value: {
                href: "https://www.fwdgi.hk/en/easy-home-insurance?utm_source=ifwd&pc=EHOME10",
                text: "Agree and continue",
                linktype: "external",
                url: "https://www.fwdgi.hk/en/easy-home-insurance?utm_source=ifwd&pc=EHOME10",
                anchor: "",
                target: "",
              },
            },
            buttonMode: {
              id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
              fieldType: "Droplink",
              fieldName: "buttonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
              fields: {
                value: { value: "Primary" },
                key: { value: "Primary" },
              },
            },
            linkGALabelName: { value: "" },
            closeCTALabel: { value: "" },
            isCloseCTA: { value: false },
            secondaryLinkButtonMode: {
              id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
              fieldType: "Droplink",
              fieldName: "secondaryLinkButtonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
              fields: {
                value: { value: "Secondary" },
                key: { value: "Secondary" },
              },
            },
            secondaryLinkGALabelName: { value: "" },
            secondaryLink: { value: {} },
            secondaryLinkButtonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "secondaryLinkButtonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            secondaryCloseCTALabel: { value: "" },
            isSecondaryCloseCTA: { value: false },
            FormParameters: { value: {} },
            IsFormPost: { value: false },
            id: "81e0fce7-b5ed-4ff2-959a-d1ef9a1d1fd9",
          },
          {
            title: {
              value:
                "You are being redirected to the website of FWD General Insurance Company Limited (“FWD GI”), a Bolttech company",
            },
            footerText: { value: "" },
            text: {
              value:
                'Such redirection does not constitute endorsement, approval, warranty or representation, express or implied, by FWD Life Insurance Company (Bermuda) Limited (incorporated in Bermuda with limited liability) ("FWD Life") of FWD GI or the hypertext link, product, service or information contained or available in FWD GI&rsquo;s website. FWD Life is not in any way responsible for the contents available in the linked FWD GI&rsquo;s website and shall not be responsible for any damage or losses incurred or suffered by you arising out of or in connection with your use of the link.',
            },
            sticky: { value: true },
            activeAtEndOfScroll: { value: true },
            isRiskDisclosure: { value: true },
            defaultPageLink: {
              value: {
                href: "https://www.fwd.com.hk/en/products/travel-golf/travel-care-insurance/",
                text: "",
                anchor: "",
                linktype: "internal",
                class: "",
                title: "",
                target: "",
                querystring: "",
                id: "{42609B4A-3495-46CB-93CD-20B2BA82AABD}",
              },
            },
            sessionTimeout: { value: "1" },
            enableSmallView: { value: false },
            frequency: {
              id: "0585858d-6024-4df6-a556-08bc04932510",
              fieldType: "Droplink",
              fieldName: "frequency",
              url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
              fields: {
                value: { value: "Every time user land on the identified page" },
                key: { value: "every-time-in-session" },
              },
            },
            buttonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "buttonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            link: {
              value: {
                href: "https://www.fwdgi.hk/en/travel-insurance?utm_source=ifwd&pc=TRAVEL30",
                text: "Agree and continue",
                linktype: "external",
                url: "https://www.fwdgi.hk/en/travel-insurance?utm_source=ifwd&pc=TRAVEL30",
                anchor: "",
                target: "",
              },
            },
            buttonMode: {
              id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
              fieldType: "Droplink",
              fieldName: "buttonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
              fields: {
                value: { value: "Primary" },
                key: { value: "Primary" },
              },
            },
            linkGALabelName: { value: "" },
            closeCTALabel: { value: "" },
            isCloseCTA: { value: false },
            secondaryLinkButtonMode: {
              id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
              fieldType: "Droplink",
              fieldName: "secondaryLinkButtonMode",
              url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
              fields: {
                value: { value: "Secondary" },
                key: { value: "Secondary" },
              },
            },
            secondaryLinkGALabelName: { value: "" },
            secondaryLink: { value: {} },
            secondaryLinkButtonIcon: {
              id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
              fieldType: "CustomDroplink",
              fieldName: "secondaryLinkButtonIcon",
              url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
              fields: {
                value: { value: "arrow-right" },
                key: { value: "Link" },
              },
            },
            secondaryCloseCTALabel: { value: "" },
            isSecondaryCloseCTA: { value: false },
            FormParameters: { value: {} },
            IsFormPost: { value: false },
            id: "70835a3d-3089-4cb4-9520-cb33336b4eac",
          },
        ],
      },
      localizedPages: [
        { "en-hk": "https://www.fwd.com.hk/en/products" },
        { "zh-Hant-hk": "/products" },
      ],
      isRequestFromExternalSource: false,
      availableLanguages: ["en", "tc"],
    },
    productDetails: {
      initializer: "bookAnAgent",
      enquiryInitializer: "SUPPORT",
      productName: "",
      minAge: "",
      maxAge: "",
      minSumAssured: "",
      maxSumAssured: "",
      calculationOptions: [],
      sumAssuredSelectionType: "",
      premiumSelectionType: "",
      minPremiumYearly: "",
      maxPremiumYearly: "",
      sumAssuredRange: "",
      sumAssuredPaymentMode: [],
      purchaseMethod: [],
      premiumRange: "",
      premiumStepperInterval: "",
      sumAssuredStepperInterval: "",
      plans: [],
      ridersAvailable: null,
      enableEnquiryForRiders: null,
      associatedItems: [],
      filteredAssociatedItems: [],
      allPlanCards: [],
      productType: "",
      talkToAgentLink: null,
      talkToAgentTitle: "",
      expectedInsuranceType: "",
      parameters: null,
      expectedInsuranceTypeProductCard: "",
      parametersProductCard: "",
    },
    formLinks: {
      calculateFormLink: "",
      recommenderFormLink: "",
      enquiryFormLink: "",
      callbackFormLink:
        "https://www.fwd.com.hk/sitecore/api/layout/render/jss?item=/forms-list/product-enquiry-form&sc_lang=en&sc_apikey={D7333054-1DCE-4B0C-A9A5-AC7372A796AB}",
    },
    finalizer: "",
    apiStatus: {
      loading: false,
      apiStatus: null,
      errorCode: "",
      failCounter: 0,
    },
    form: {
      sitecore: {
        context: {
          pageEditing: false,
          site: { name: "fwd-hk" },
          pageState: "normal",
          language: "en",
          languageCode: "en",
          defaultLanguage: "zh-HK",
          siteSettings: {
            productListPage: "/products/",
            splashPage: "",
            articleTagLink: "/search/",
            articleTypeDesign: [],
            articleOverlineText: false,
            globalMetaText: "FWD HK",
            globalMetaTag: "",
            cookieMessage:
              '<p>We use cookies to give you the best possible experience on our website. By continuing to browse this site, you give consent for cookies to be used. </p>\n<p>For more details please read our <a href="~/link.aspx?_id=DCD61657FA884252B0580B7EBE7F06F1&amp;_z=z">Cookie Policy</a>.</p>',
            cookieTimeStamp: "10",
            currencyPlacement: "BeforeNumericals",
            currencyWhitespace: false,
            currencySeparator: { value: {} },
            currencyLabel: { value: { USD: "US$", EUR: "EUR", HKD: "HK$" } },
            splashPageUpdatedDuration: "10",
            splashPageUpdatedDate: "",
            faviconImageUrl:
              "/-/media/global/images/icons/favicon.ico?rev=51cce1bfcfb347b3b2fc7d304180401d",
            productErrorPictogramUrl:
              "/-/media/pictograms/no-result-48px2x.png?rev=6b3f1e7975b545d780c8a676eb165ef0",
            dateFormat: "D MMMM YYYY",
            enablePlanCardSharePostCalc: "",
            sessionTimeout: "20",
            loaderTimeout: "20",
            gAID: "GTM-N6B3G67",
            gTMID: "GTM-N6B3G67",
            gtmParamters: [],
            optimize360: true,
            hostName: "https://www.fwd.com.hk",
            enableBackToTopButton: 1,
            dialogSessionTimeout: "20",
            productFallbackCTA: {
              value: {
                href: "/forms-list/product-enquiry-form",
                text: "Enquire",
                anchor: "Enquire",
                linkType: "form",
                title: "Enquire",
                queryString: "enquiry",
                id: "{F2728281-FA5C-41CB-B168-773E0C78197F}",
                gaLabel: "Enquiry",
              },
            },
            brightcoveAccountID: "5650355171001",
            languageIcon: { key: "language-globe", value: "language-globe" },
            enableMultipleNotifications: true,
            hidePrimaryLanguage: true,
            currencyGALabelName: "",
            showArticleSubtitle: false,
            hasArticleSubtitleFallback: false,
          },
          share: {
            socialApps: [
              {
                facebook: {
                  url: {
                    value: {
                      href: "https://www.facebook.com/sharer.php?u=",
                      text: "Facebook Url",
                      linktype: "external",
                      url: "https://www.facebook.com/sharer.php?u=",
                      anchor: "",
                      target: "",
                    },
                  },
                  header: { value: "Share on Facebook" },
                  toolTip: { value: "" },
                },
              },
              {
                Whatsapp: {
                  url: {
                    value: {
                      href: "https://web.whatsapp.com/send?text=",
                      linktype: "external",
                      url: "https://web.whatsapp.com/send?text=",
                      anchor: "",
                      target: "",
                    },
                  },
                  header: { value: "Share on Whatsapp" },
                  toolTip: { value: "" },
                },
              },
              {
                Linkedin: {
                  url: {
                    value: {
                      href: "https://www.linkedin.com/sharing/share-offsite/?url=",
                      linktype: "external",
                      url: "https://www.linkedin.com/sharing/share-offsite/?url=",
                      anchor: "",
                      target: "",
                    },
                  },
                  header: { value: "Share on Linkedin" },
                  toolTip: { value: "" },
                },
              },
            ],
          },
          siteNotifications: {
            notifications: [
              {
                hidePublishDate: { value: true },
                publishDate: "2022-08-18T04:08:00Z",
                description: {
                  value:
                    '<span style="color: #273d35;">FWD launched &lsquo;Free Special Benefit Against Vaccination Complications&rsquo;.&nbsp;</span>Please click <a href="https://www.fwd.com.hk/en/coronavirusfaq">here</a>&nbsp;for details.',
                },
                expiryDate: "2024-03-30T03:30:00Z",
                pagesList: { value: "/" },
                icon: {
                  id: "c0c57154-6ec6-4264-8d86-a4efebbd1533",
                  fieldType: "CustomDroplink",
                  fieldName: "icon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/notification---obsolete",
                  fields: {
                    value: { value: "notification-icon" },
                    key: { value: "Notification" },
                  },
                },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-08-03T04:14:00Z",
                description: {
                  value:
                    "<p>COVID-19 NOTICE: Our FWD Insurance Solutions Centres (ISC) are providing service from 9:30am to 5:30pm from Monday to Saturday, and closed on Sunday and public holidays. Our customer hotline provides service from 9am to 6pm daily.</p>",
                },
                expiryDate: "2025-11-08T01:00:00Z",
                pagesList: { value: "/,/business/" },
                icon: {
                  id: "c4ce9c6d-80fa-402f-9b49-87c412a21684",
                  fieldType: "CustomDroplink",
                  fieldName: "icon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/alert---obsolete",
                  fields: {
                    value: { value: "alert" },
                    key: { value: "alert" },
                  },
                },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-02-22T08:06:00Z",
                description: {
                  value:
                    'This website (<a href="https://www.fwd.com.hk/en/claims">https://fwd.com.hk/en/claims</a>) is operated by FWD Financial Limited, an appointed and licensed insurance agent of FWD Life Insurance Company (Bermuda) Limited and FWD General Insurance Company Limited.',
                },
                expiryDate: "2030-02-22T00:00:00Z",
                pagesList: { value: "/claims/" },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-02-22T08:06:00Z",
                description: {
                  value:
                    'This website (<a href="https://www.fwd.com.hk/en/products">https://fwd.com.hk/en/products</a>) is operated by FWD Financial Limited, an appointed and licensed insurance agent of FWD Life Insurance Company (Bermuda) Limited and FWD General Insurance Company Limited.',
                },
                expiryDate: "2030-02-22T00:00:00Z",
                pagesList: { value: "/products/" },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-02-22T08:06:00Z",
                description: {
                  value:
                    'This website (<a href="https://www.fwd.com.hk/en/support/">https://fwd.com.hk/en/support</a>) is operated by FWD Financial Limited, an appointed and licensed insurance agent of FWD Life Insurance Company (Bermuda) Limited and FWD General Insurance Company Limited.',
                },
                expiryDate: "2030-02-22T00:00:00Z",
                pagesList: { value: "/support/" },
              },
              {
                hidePublishDate: { value: true },
                publishDate: "2022-02-24T03:04:00Z",
                description: {
                  value:
                    "This website (https://fwd.com.hk) is operated by FWD Life Insurance Company (Bermuda) Limited.",
                },
                expiryDate: "2025-11-08T01:00:00Z",
                pagesList: { value: "/, /business/" },
                icon: {
                  id: "c4ce9c6d-80fa-402f-9b49-87c412a21684",
                  fieldType: "CustomDroplink",
                  fieldName: "icon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/alert---obsolete",
                  fields: {
                    value: { value: "alert" },
                    key: { value: "alert" },
                  },
                },
              },
            ],
          },
          dialogModals: {
            modalList: [
              {
                activeSessionModal: {
                  title: { value: "Are you still here?" },
                  description: {
                    value:
                      "This page will expire in {time} seconds. You've been inactive for some time. Select continue to stay on page.",
                  },
                  key: {
                    id: "bab3dabc-242d-419f-bc41-f342458cb50a",
                    fieldType: "Droplink",
                    fieldName: "key",
                    url: "/sitecore/content/fwd/global/settings/list/dialog-modal/activesessionmodal",
                    fields: {
                      value: { value: "ActiveSessionModal" },
                      key: { value: "activeSessionModal" },
                    },
                  },
                  buttonIcon: {
                    id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                    fieldType: "CustomDroplink",
                    fieldName: "buttonIcon",
                    url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                    fields: {
                      value: { value: "arrow-right" },
                      key: { value: "Link" },
                    },
                  },
                  link: { value: {} },
                  buttonMode: {
                    id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                    fieldType: "Droplink",
                    fieldName: "buttonMode",
                    url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                    fields: {
                      value: { value: "SimpleLink" },
                      key: { value: "SimpleLink" },
                    },
                  },
                  linkGALabelName: { value: "" },
                  secondaryLinkButtonMode: {
                    id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                    fieldType: "Droplink",
                    fieldName: "secondaryLinkButtonMode",
                    url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                    fields: {
                      value: { value: "Secondary" },
                      key: { value: "Secondary" },
                    },
                  },
                  secondaryLinkGALabelName: { value: "" },
                  secondaryLink: { value: {} },
                  secondaryLinkButtonIcon: {
                    id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                    fieldType: "CustomDroplink",
                    fieldName: "secondaryLinkButtonIcon",
                    url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                    fields: {
                      value: { value: "arrow-right" },
                      key: { value: "Link" },
                    },
                  },
                },
              },
              {
                expiredSessionModal: {
                  title: { value: "The page has expired" },
                  description: {
                    value:
                      "It looks like you've been inactive for some time. Your information hasn't been stored. Please refresh and try again.",
                  },
                  key: {
                    id: "13bd5030-db40-4148-a65f-678b8f0fb5a5",
                    fieldType: "Droplink",
                    fieldName: "key",
                    url: "/sitecore/content/fwd/global/settings/list/dialog-modal/expiredsessionmodal",
                    fields: {
                      value: { value: "ExpiredSessionModal" },
                      key: { value: "expiredSessionModal" },
                    },
                  },
                  buttonIcon: {
                    id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                    fieldType: "CustomDroplink",
                    fieldName: "buttonIcon",
                    url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                    fields: {
                      value: { value: "arrow-right" },
                      key: { value: "Link" },
                    },
                  },
                  link: { value: {} },
                  buttonMode: {
                    id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                    fieldType: "Droplink",
                    fieldName: "buttonMode",
                    url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                    fields: {
                      value: { value: "Primary" },
                      key: { value: "Primary" },
                    },
                  },
                  linkGALabelName: { value: "" },
                  secondaryLinkButtonMode: {
                    id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                    fieldType: "Droplink",
                    fieldName: "secondaryLinkButtonMode",
                    url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                    fields: {
                      value: { value: "Secondary" },
                      key: { value: "Secondary" },
                    },
                  },
                  secondaryLinkGALabelName: { value: "" },
                  secondaryLink: { value: {} },
                  secondaryLinkButtonIcon: {
                    id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                    fieldType: "CustomDroplink",
                    fieldName: "secondaryLinkButtonIcon",
                    url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                    fields: {
                      value: { value: "arrow-right" },
                      key: { value: "Link" },
                    },
                  },
                },
              },
            ],
          },
          disclosurePopups: {
            popupList: [
              {
                title: { value: "Risk Disclosure Statements" },
                footerText: { value: "" },
                text: {
                  value:
                    '<div style="display: none;">&nbsp;</div>\n<p style="text-align: center;">(Applicable to Investment-linked Assurance Schemes only)\n</p>\n<ul>\n    <li>The following investment choices are available for the investment-linked assurance schemes ("ILAS") issued by FWD Insurance Company (Bermuda) Limited<span style="color: #183028;">(incorporated in Bermuda with limited liability)</span>("FWD"). Your investments are subject to the credit risks of FWD.</li>\n</ul>\n<ul>\n    <li><span style="color: #183028;">Although your ILAS is a life insurance policy, because your death benefit is linked to the performance of the investment choice you selected from time to time, your death benefit is subject to investment risks and market fluctuations. The death benefit payable may be significantly less than your premiums paid and may not be sufficient for your individual needs.</span></li>\n</ul>\n<ul>\n    <li><span style="color: #183028;">The premiums paid by you towards the ILAS, and any investments made by FWD in the underlying funds corresponding to the investment choices you selected, will become and remain part of the assets of FWD. You do not have any rights or ownership over these underlying investments. Your recourse is against FWD only.</span></li>\n</ul>\n<ul>\n    <li>The premiums paid by you will be invested by FWD into the underlying funds corresponding to the investment choices as selected by you for FWD&rsquo;s asset liability management. However, the unit(s) allocated to your policy account is notional and is solely for the purpose of determining the account value and benefits under your policy.</li>\n</ul>\n<ul>\n    <li><span style="color: #183028;">Your return on investment is calculated by FWD with reference to the performance of the underlying funds.&nbsp; Besides, your return shall be subject to ongoing fees and charges which will continue to be deducted from the ILAS, hence, it may be lower than the return of the corresponding underlying funds. Each of the underlying funds has its own investment profile and associated risks. Underlying funds corresponding to the investment choices available for selection are listed in the investment choices brochure. These underlying funds are authorized by the SFC pursuant to the Code on Unit Trusts and Mutual Funds. Please note that SFC authorization is not a recommendation or endorsement of a scheme nor does it guarantee the commercial merits of a scheme or its performance. It does not mean the scheme is suitable for all investors nor is it an endorsement of its suitability for any particular investors or class of investors.</span></li>\n</ul>\n<ul>\n    <li><span style="color: #183028;">Early termination, surrender or withdrawal of the account value of the ILAS may result in significant loss of your investment and principal paid as well as bonuses awarded (if applicable). Poor performance of the underlying funds may further magnify your investment losses while all charges are still deductible. Besides, FWD may effect termination of your ILAS if your policy is held by an incorporation which is a non-participating Foreign Financial Institutions in respect of U.S. Foreign Account Tax Compliance Act.</span></li>\n</ul>\n<ul>\n    <li>The investment choices available under ILAS can have very different features and risk profiles. Some may be of high risk.The underlying funds of some investment choices is/ are derivative fund with net derivative exposure exceeding 50% of its net asset value. It may only be suitable for investors who understand the complicated structure of derivative product and associated risk. You may incur significant loss if investing in such investment choices. You are strongly advised to exercise caution in relation to such investment choice(s).</li>\n</ul>\n<ul>\n    <li>You should not purchase this product unless you understand it and it has been explained to you how it is suitable for you. The final decision is yours.</li>\n</ul>\n<ul>\n    <li><span style="color: #183028;">Investment choice(s) which denoted the names ended with (&ldquo;Dis&rdquo;) (collectively, the &ldquo;Investment Choices (Cash Distribution)&rdquo;) are linked to the share class of the underlying funds that aim to pay dividend regularly. Investment Choices (Cash Distribution) may distribute cash dividend. If you choose to invest in such investment choice(s), you will receive cash dividend if FWD receive such dividend from the underlying fund(s) of the investment choice(s). However, please note that:</span><span style="color: #183028;">&nbsp;</span>\n    <ol style="list-style-type: lower-roman;">\n        <li><span style="color: #183028;">the corresponding underlying fund of the respective Investment Choices (Cash Distribution) may at its discretion effectively pay dividend out of the capital of the underlying fund (i.e. gross income while charging/ paying all or part of the underlying fund&rsquo;s fees and expenses to/ out of the capital of the underlying fund, resulting in an increase in distributable income for the payment of dividends by the underlying fund).</span><span style="color: #183028;"></span></li>\n        <li><span style="color: #183028;">payment of dividends out of capital by the corresponding underlying fund amounts to a return or withdrawal of part of an investor&rsquo;s original investment or from any capital gains attributable to that original investment. </span></li>\n        <li><span style="color: #183028;">any distributions involving payment of dividends out of capital may result in an immediate reduction of the net asset value per unit of the underlying fund, which may have a negative impact on the price of the Investment Choice (Cash Distribution). This may in turn reduce and result in a deduction to the account value of your policy. In this case, death benefit, surrender benefit and maturity benefit will be reduced.</span> </li>\n        <li><span style="color: #183028;">It is not guaranteed that the underlying fund of an Investment Choice (Cash Distribution) will distribute cash dividend or distribute a fixed amount of cash dividend or distribute cash dividend at a periodic frequency. The amount of cash dividend paid is in no way an indication, a forecast or a projection of cash dividends to be paid in the future.</span></li>\n    </ol>\n    </li>\n</ul>\n<div style="text-align: left;"><strong><span style="color: #183028;">Investment involves risks. For details and charges of ILAS, please refer to the offering documents of ILAS and the underlying funds.</span></strong></div>\n<p style="text-align: left;"><strong>Investment involves risks. Past performance should not be taken as an indication of future performance. You should not invest based on this material alone. You should read ILAS offering documents for details including the risk factors.</strong><br />\n<strong></strong></p>\n<div style="text-align: left;"><strong>\n<br />\nIssued by<br />\nFWD Life Insurance Company (Bermuda) Limited&nbsp;<strong><span style="color: #183028;">(incorporated in Bermuda with limited liability)</span></strong></strong></div>',
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "https://www.fwd.com.hk/en/products/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{DB3FF0BC-2E10-4735-8BAA-76A87A906821}",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "8342b7fa-a8ba-4fd5-b7ca-fea9248e4f42",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/once-in-browsing-session",
                  fields: {
                    value: { value: "Once in browsing session" },
                    key: { value: "once-in-browsing-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwd.com.hk/en/products/invest/",
                    text: "YES, I’ve read and understand the above information.",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{2375DA5B-104B-4B0C-A915-78223732320F}",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: {
                  value: "NO, I don’t want to continue",
                },
                isSecondaryCloseCTA: { value: true },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "a502d7b5-56e5-49ee-af75-d767bb290981",
              },
              {
                title: { value: "" },
                footerText: { value: "" },
                text: {
                  value:
                    "The MPF products distributed by FWD are now provided by Sun Life. You will be redirected to the website of the respective MPF Scheme Administrator for checking your MPF account.",
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: false },
                defaultPageLink: {
                  value: {
                    href: "https://www.fwd.com.hk/en/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{9CB72689-FA18-4900-B876-3AE397D3B009}",
                  },
                },
                sessionTimeout: { value: "10" },
                enableSmallView: { value: false },
                frequency: {
                  id: "8342b7fa-a8ba-4fd5-b7ca-fea9248e4f42",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/once-in-browsing-session",
                  fields: {
                    value: { value: "Once in browsing session" },
                    key: { value: "once-in-browsing-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://cs01.cspension.com.hk/fwdweb/",
                    text: "Visit",
                    linktype: "external",
                    url: "https://cs01.cspension.com.hk/fwdweb/",
                    anchor: "",
                    target: "_blank",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "d6037e42-3522-4edd-8cd8-f814f3528e6b",
              },
              {
                title: { value: "" },
                footerText: { value: "" },
                text: {
                  value:
                    '<p>FWD and Sun Life have entered into a strategic relationship for Hong Kong Retirement Services</p>\n<p>With effect from 3 October, 2017, the sponsor of FWD MPF Schemes has been changed to Sun Life Hong Kong Limited (&ldquo;Sun Life&rdquo;) and the FWD MPF Master Trust Basic / Comprehensive Schemes have been changed to Sun Life MPF Basic / Comprehensive Scheme.</p>\n<p>FWD Life Insurance Company (Bermuda) Limited (&ldquo;FWD&rdquo;) and Sun Life have also entered into a 15-year strategic distribution agreement allowing FWD&rsquo;s tied agency to distribute Sun Life&rsquo;s MPF products in the Hong Kong market.</p>\n<p>For further information on Sun Life&rsquo;s MPF schemes, please click "visit" to Sun Life Hong Kong&rsquo;s homepage and the Customer Corner where you can log on to the Online Pension Services Centre. For enquiries about the related MPF scheme, please call (852) 3183 1900.</p>\n<p>The investments mentioned in this website may not be suitable to all investors. The information contained in this website is provided for reference only and does not constitute any investment advice. Investors are advised to seek independent advice before making any investment decision.</p>\n<p>Investment involves risk and investors may not get back the amount originally invested. Past performance is not indicative of future performance. Please read the relevant offering document carefully, in particular fund features and risks factors.</p>\n<p>FWD is regulated by the SFC. Non-Hong Kong residents are responsible for observing all applicable laws and regulations of their relevant jurisdictions before proceeding to access the information contained herein.</p>\n<div>&nbsp;</div>',
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: false },
                defaultPageLink: {
                  value: {
                    href: "https://www.fwd.com.hk/en/products/invest/orso/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
                  },
                },
                sessionTimeout: { value: "10" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: null,
                link: {
                  value: {
                    href: "https://www.sunlife.com.hk/en/investments/mpf-orso-fund-prices-performance/?vgnLocale=zh_en",
                    text: "Visit",
                    linktype: "external",
                    url: "https://www.sunlife.com.hk/en/investments/mpf-orso-fund-prices-performance/?vgnLocale=zh_en",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: {
                  value: {
                    href: "https://www.fwd.com.hk/en/products/invest/orso/",
                    text: "Close",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
                  },
                },
                secondaryLinkButtonIcon: null,
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: true },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "6907d3f8-481b-419c-b333-a1a0f654b773",
              },
              {
                title: { value: "" },
                footerText: { value: "" },
                text: {
                  value:
                    '<p><strong>IMPORTANT</strong></p>\n<ul>\n    <li>FWD Multi-Funding Provident Plan (the "Plan") is a pooled retirement scheme established by an insurance policy issued by FWD Life Insurance Company (Bermuda) Limited ("FWD Life").</li>\n    <li>The guarantee of the FWD Capital Guarantee Fund is provided by FWD Life. Your investments in FWD Capital Guarantee Fund are therefore subject to the credit risks of FWD Life. The guarantee is subject to qualifying conditions as set out in Appendix 1 to the Explanatory Memorandum in respect of the FWD Capital Guarantee Fund.</li>\n    <li>Each of the Managed Funds of the Scheme will invest in the corresponding Underlying Funds. Such Underlying Funds may invest in equities, debt securities and/or financial derivative instruments, as the case may be, each with a different risk profile.</li>\n    <li>Underlying Funds which invest in emerging markets may be subject to higher liquidity and volatility risks. Underlying Funds which invest in a particular market or sector may be subject to a higher concentration risk than funds with a more diversified investment policy.</li>\n    <li>Underlying Funds which invest in debt securities that are low-rated or non-investment grade debt securities may be subject to higher credit and counterparty risks than funds which invest in debt securities with higher credit ratings.</li>\n    <li>Underlying Funds which invest substantially in financial derivative instruments may be subject to significant liquidity and counterparty default risks and therefore may expose the Underlying Funds to the potential for significant losses.</li>\n    <li>The Scheme is constituted in the form of an insurance policy. While the benefit payments under the Scheme are calculated with reference to the performance of the Investment Options, you are not investing in the underlying investment funds / assets and do not have any rights or ownership over the underlying investment funds / assets.&nbsp; Such underlying investment funds / assets are legally owned by FWD Life.&nbsp; You only have a contractual right to claim the amount representing the benefits under the Scheme from FWD Life.&nbsp; Your investment in the Scheme is therefore subject to the credit risks of FWD Life.</li>\n    <li>You should consider your own risk tolerance level and financial circumstances before making any investment choices. If you are in doubt as to whether a Managed Fund is suitable for you (including whether it is consistent with your investment objectives), you should seek independent financial and/or professional advice.</li>\n    <li>You should not invest based on this website alone. You should read this Explanatory Memorandum for further details including product features, fees and charges and risk factors (set out in section 3 headed "INVESTMENT RISKS AND RISK FACTORS").</li>\n</ul>\n<p><strong>Important Notes:</strong></p>\n<ul>\n    <li>The Plan has been authorized by the Securities and Futures Commission ("SFC"). Such authorization does not imply any official recommendation by the SFC.</li>\n    <li>Investment involves risk and past performance information presented is not indicative of future performance. Not all investment choice available under the Plan would be suitable for everyone. There is no assurance on investment returns and your investments/accrued benefits may suffer significant losses.</li>\n    <li>For further details including the features of the Plan, please refer to the details in the Explanatory Memorandum. Please refer to the latest offering documents of the underlying funds. If you are in doubt about the meaning or effect of the contents of the Explanatory Memorandum and the offering document of each underlying fund, you should seek professional advice.</li>\n</ul>\n<p>Issued by FWD Life Insurance Company (Bermuda) Limited.</p>\n<p><strong>IMPORTANT INFORMATION</strong></p>\n<p>PLEASE READ CAREFULLY AND CLICK THE <strong>ACCEPT</strong> BUTTON TO CONTINUE.</p>\n<p>Information contained in this web site is provided "AS IS" and "AS AVAILABLE". The Company does not warrant the adequacy of these information and materials. No warranty of any kind, implied, express or statutory, including but not limited to the copyright, title, merchantability, fitness for a particular purpose and freedom from computer virus, is given in conjunction with the information and materials.</p>\n<p>Information is current as at the date of publication but is subject to change without notice.</p>\n<p>Registration with, or approval or authorization by the Mandatory Provident Fund Schemes Authority and the Securities and Futures Commission does not imply official recommendation.</p>\n<p>Investment involves risk and the prices of units may go down as well as up. Past performance figures shown are not indicative of future returns. Please refer to the relevant Explanatory Memorandum/Offering Document for further details.</p>',
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: false },
                isRiskDisclosure: { value: false },
                defaultPageLink: {
                  value: {
                    href: "https://www.fwd.com.hk/en/products/invest/orso/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
                  },
                },
                sessionTimeout: { value: "2" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: null,
                link: {
                  value: {
                    href: "https://www.fwd.com.hk/en/products/invest/orso/fund-performance/",
                    text: "Accept",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{08204FFD-2104-462A-9271-72552A3B5491}",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: {
                  value: {
                    href: "https://www.fwd.com.hk/en/products/invest/orso/",
                    text: "Not Accept",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{1350A039-E306-4354-B38B-5BFB085DEC5A}",
                  },
                },
                secondaryLinkButtonIcon: null,
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: true },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "a87c6d76-dac0-4e31-b731-fd439a9d247b",
              },
              {
                title: { value: "Before you leave our website" },
                footerText: { value: "" },
                text: {
                  value:
                    'This link will bring you to another website that is not operated by FWD Life. FWD Life is not responsible in any way for the information provided on any other website.<br />\n<br />\nProviding this link does not mean that FWD Life endorses or guarantees anything about the operators of that website, or about the information, products, or services provided by them.<br />\n<br />\nI confirm that I have read, understood and accepted FWD Life&rsquo;s <a href="/404?item=web%3a%7bE10372DB-B865-433F-B3FE-C0F40018E4AA%7d%40en">Personal Information Collection Statement (&ldquo;PICS&rdquo;) </a>and agreed to be bound by the same.<br />\n<br />\nPlease note that if you click on the link and enter the other website, you will be subject to the terms of use and privacy policies of that other website.<br />\n<div>&nbsp;</div>\n<br />',
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: false },
                isRiskDisclosure: { value: false },
                defaultPageLink: { value: {} },
                sessionTimeout: { value: "" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://wa.me/85265320781",
                    text: "Confirm and continue",
                    linktype: "external",
                    url: "https://wa.me/85265320781",
                    anchor: "",
                    target: "_blank",
                  },
                },
                buttonMode: {
                  id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                  fields: {
                    value: { value: "SimpleLink" },
                    key: { value: "SimpleLink" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "Back" },
                isSecondaryCloseCTA: { value: true },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "9393cb81-8d91-4cda-a494-70ab242c70a4",
              },
              {
                title: {
                  value: "You are being redirected to the website of bolttech",
                },
                footerText: { value: "" },
                text: {
                  value:
                    'Such redirection does not constitute endorsement, approval, warranty or representation, express or implied, by FWD Life Insurance Company (Bermuda) Limited (incorporated in Bermuda with limited liability) ("FWD Life") of bolttech or the hypertext link, product, service or information contained or available in bolttech&rsquo;s website. FWD Life is not in any way responsible for the contents available in the linked bolttech&rsquo;s website and shall not be responsible for any damage or losses incurred or suffered by you arising out of or in connection with your use of the link.',
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "/fwd/fwd-hk/Home/Products/car-boat/motor-smart-plus",
                    linktype: "external",
                    url: "/fwd/fwd-hk/Home/Products/car-boat/motor-smart-plus",
                    anchor: "",
                    target: "",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwdgi.hk/en/car-insurance?pc=FMSPO10&utm_source=ifwd&utm_medium=referral&utm_content=buynowbutton",
                    text: "Agree and continue",
                    linktype: "external",
                    url: "https://www.fwdgi.hk/en/car-insurance?pc=FMSPO10&utm_source=ifwd&utm_medium=referral&utm_content=buynowbutton",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "5ff33e21-1230-4247-8dfe-ae59221944fa",
              },
              {
                title: {
                  value:
                    "You are being redirected to the website of FWD General Insurance Company Limited (“FWD GI”), a Bolttech company",
                },
                footerText: { value: "" },
                text: {
                  value:
                    'Such redirection does not constitute endorsement, approval, warranty or representation, express or implied, by FWD Life Insurance Company (Bermuda) Limited (incorporated in Bermuda with limited liability) ("FWD Life") of FWD GI or the hypertext link, product, service or information contained or available in FWD GI&rsquo;s website. FWD Life is not in any way responsible for the contents available in the linked FWD GI&rsquo;s website and shall not be responsible for any damage or losses incurred or suffered by you arising out of or in connection with your use of the link.',
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "/fwd/fwd-hk/Home/Products/helper/helper-care-insurance",
                    linktype: "external",
                    url: "/fwd/fwd-hk/Home/Products/helper/helper-care-insurance",
                    anchor: "",
                    target: "",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwdgi.hk/en/domestic-helper-insurance?utm_source=ifwd&utm_content=buynowbutton&pc=HELPER10",
                    text: "Agree and continue",
                    linktype: "external",
                    url: "https://www.fwdgi.hk/en/domestic-helper-insurance?utm_source=ifwd&utm_content=buynowbutton&pc=HELPER10",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "0a84b12a-2810-414e-a01c-ffc8f28b71c0",
              },
              {
                title: {
                  value:
                    "You are being redirected to the website of FWD General Insurance Company Limited (“FWD GI”), a Bolttech company",
                },
                footerText: { value: "" },
                text: {
                  value:
                    'Such redirection does not constitute endorsement, approval, warranty or representation, express or implied, by FWD Life Insurance Company (Bermuda) Limited (incorporated in Bermuda with limited liability) ("FWD Life") of FWD GI or the hypertext link, product, service or information contained or available in FWD GI&rsquo;s website. FWD Life is not in any way responsible for the contents available in the linked FWD GI&rsquo;s website and shall not be responsible for any damage or losses incurred or suffered by you arising out of or in connection with your use of the link.',
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "/fwd/fwd-hk/Home/Products/household-pets/home-care-insurance/",
                    linktype: "external",
                    url: "/fwd/fwd-hk/Home/Products/household-pets/home-care-insurance/",
                    anchor: "",
                    target: "",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwdgi.hk/en/home-care-insurance?utm_source=ifwd&utm_content=buynowbutton&&pc=HOMEC10",
                    text: "Agree and continue",
                    linktype: "external",
                    url: "https://www.fwdgi.hk/en/home-care-insurance?utm_source=ifwd&utm_content=buynowbutton&&pc=HOMEC10",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "1af378f3-ec18-4f13-90aa-37c28070087d",
              },
              {
                title: {
                  value:
                    "You are being redirected to the website of FWD General Insurance Company Limited (“FWD GI”), a Bolttech company",
                },
                footerText: { value: "" },
                text: {
                  value:
                    'Such redirection does not constitute endorsement, approval, warranty or representation, express or implied, by FWD Life Insurance Company (Bermuda) Limited (incorporated in Bermuda with limited liability) ("FWD Life") of FWD GI or the hypertext link, product, service or information contained or available in FWD GI&rsquo;s website. FWD Life is not in any way responsible for the contents available in the linked FWD GI&rsquo;s website and shall not be responsible for any damage or losses incurred or suffered by you arising out of or in connection with your use of the link.',
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "https://www.fwd.com.hk/en/products/household-pets/easy-home-care/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{4C2582F3-9667-4957-B3F9-53C8056EBA7F}",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwdgi.hk/en/easy-home-insurance?utm_source=ifwd&pc=EHOME10",
                    text: "Agree and continue",
                    linktype: "external",
                    url: "https://www.fwdgi.hk/en/easy-home-insurance?utm_source=ifwd&pc=EHOME10",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "81e0fce7-b5ed-4ff2-959a-d1ef9a1d1fd9",
              },
              {
                title: {
                  value:
                    "You are being redirected to the website of FWD General Insurance Company Limited (“FWD GI”), a Bolttech company",
                },
                footerText: { value: "" },
                text: {
                  value:
                    'Such redirection does not constitute endorsement, approval, warranty or representation, express or implied, by FWD Life Insurance Company (Bermuda) Limited (incorporated in Bermuda with limited liability) ("FWD Life") of FWD GI or the hypertext link, product, service or information contained or available in FWD GI&rsquo;s website. FWD Life is not in any way responsible for the contents available in the linked FWD GI&rsquo;s website and shall not be responsible for any damage or losses incurred or suffered by you arising out of or in connection with your use of the link.',
                },
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                isRiskDisclosure: { value: true },
                defaultPageLink: {
                  value: {
                    href: "https://www.fwd.com.hk/en/products/travel-golf/travel-care-insurance/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{42609B4A-3495-46CB-93CD-20B2BA82AABD}",
                  },
                },
                sessionTimeout: { value: "1" },
                enableSmallView: { value: false },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwdgi.hk/en/travel-insurance?utm_source=ifwd&pc=TRAVEL30",
                    text: "Agree and continue",
                    linktype: "external",
                    url: "https://www.fwdgi.hk/en/travel-insurance?utm_source=ifwd&pc=TRAVEL30",
                    anchor: "",
                    target: "",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                closeCTALabel: { value: "" },
                isCloseCTA: { value: false },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: { value: "" },
                isSecondaryCloseCTA: { value: false },
                FormParameters: { value: {} },
                IsFormPost: { value: false },
                id: "70835a3d-3089-4cb4-9520-cb33336b4eac",
              },
            ],
          },
          localizedPages: [
            {
              "en-hk":
                "https://www.fwd.com.hk/en/forms-list/product-enquiry-form",
            },
            { "zh-Hant-hk": "/forms-list/product-enquiry-form" },
          ],
          isRequestFromExternalSource: false,
          availableLanguages: ["en", "tc"],
        },
        route: {
          name: "Product Enquiry Form",
          displayName: "Product Enquiry Form",
          fields: {
            apiList: [
              {
                id: "2334a4bf-d431-461f-b313-1dd10100c27e",
                fields: {
                  apiName: { value: "Email" },
                  value: {
                    value: "https://prd-api-www.fwd.com/api/v1/factors/send",
                  },
                  key: {
                    value:
                      "C9VX6X34b56tC2n2b67hlL5N97VoHguVy1mVnH65KgCm0MWVATlgx9Z453Zb0gE0HXpOzo0Z6ery6oRiNN28z34mBk",
                  },
                },
              },
            ],
            formEmailTemplate: {
              value: {
                text: "",
                linktype: "form",
                querystring: "",
                target: "",
                id: "{0BA99DDB-35CD-497C-B8F4-C07C15C42F07}",
                href: "/forms-list/product-enquiry-form/product-enquiry-form-template",
                apiKey: "{D7333054-1DCE-4B0C-A9A5-AC7372A796AB}",
                apiHost: 'https://www.fwd.com.hk'

              },
            },
            enableProductName: { value: true },
            gtmEventType: null,
            dynamicFormParams: { value: {} },
          },
          databaseName: "web",
          deviceId: "fe5d7fdf-89c0-4d99-9aa3-b5fbd009c9f3",
          itemId: "f2728281-fa5c-41cb-b168-773e0c78197f",
          itemLanguage: "en",
          itemVersion: 1,
          layoutId: "e60605a5-f4f9-479a-b992-741bce767b1d",
          templateId: "d48ab251-45a3-498a-a8c1-629e33a6b9b4",
          templateName: "Form",
          placeholders: {
            "jss-metadata": [],
            "jss-header": [],
            "jss-main": [
              {
                uid: "9e687e41-fa14-4810-a780-5b42b5322ae8",
                componentName: "Forms",
                dataSource: "{67232667-4C94-4762-9F36-D07F7A5FC6E7}",
                params: { formType: "conversational" },
                fields: {
                  items: [
                    {
                      id: "cddc2c82-dcad-4ec4-9d0e-d10de405d570",
                      name: "splashPage",
                      displayName: "Splash Screen",
                      parentId: "67232667-4c94-4762-9f36-d07f7a5fc6e7",
                      fields: {
                        gaLabel: { value: "" },
                        backgroundColor: {
                          id: "b47928d6-98fc-4b29-8d0f-586ab477286e",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/orangewhite",
                          fields: {
                            value: { value: "orange-white" },
                            key: { value: "OrangeWhite" },
                          },
                        },
                        "Css Class": { value: "splashScreenPage darkMode" },
                        isHidden: { value: false },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationLoadingText: { value: "" },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "04B6B0BE40774539912EB6E4268008B9",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "79893aef-9412-46df-bca0-e770b724e0cc",
                          name: "introText",
                          displayName: "introText",
                          parentId: "cddc2c82-dcad-4ec4-9d0e-d10de405d570",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: {
                              value:
                                "Take a few minutes to enquire about this plan",
                            },
                            "Css Class": { value: "intro" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "AFCE8381306E4C6683542430C46614F4",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "9e4429dd-a09c-4e9d-8bc7-dbed05c2878b",
                          name: "Text",
                          displayName: "Text",
                          parentId: "cddc2c82-dcad-4ec4-9d0e-d10de405d570",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: {
                              value:
                                "We’ll only ask you to provide the information we need to get back to you for your enquiry made",
                            },
                            "Css Class": { value: "splashScreenDisclaimer" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "7CE5790CA96A427497DB463A5156D1D0",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "88f1a1bb-a74a-441c-b86b-4d664bc74230",
                          name: "splashScreenClick",
                          displayName: "Next Page",
                          parentId: "cddc2c82-dcad-4ec4-9d0e-d10de405d570",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "Start" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "0B059E90D26E41B2B35BE476FB35A168",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "8a59c46d-28c7-4f8b-b2d9-71bf42dc8d6d",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "88f1a1bb-a74a-441c-b86b-4d664bc74230",
                              fields: {
                                Description: { value: "Name" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{59CDD628-9C31-4A03-B612-ACBCDDF6EE59}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Redirect to page failed!",
                                    },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "59cdd628-9c31-4a03-b612-acbcddf6ee59",
                      name: "namePage",
                      displayName: "Name",
                      parentId: "67232667-4c94-4762-9f36-d07f7a5fc6e7",
                      fields: {
                        gaLabel: { value: "" },
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        "Css Class": { value: "namePage" },
                        isHidden: { value: false },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationLoadingText: { value: "" },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "F2B07BE6685F41968F59E8E76ABBC8AD",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "9c017179-888c-4939-bb8f-69b536b44cc3",
                          name: "Text",
                          displayName: "Text",
                          parentId: "59cdd628-9c31-4a03-b612-acbcddf6ee59",
                          fields: {
                            "Html Tag": { value: "h3" },
                            Text: { value: "I'm" },
                            "Css Class": { value: "block" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "04919D66DA774E6D896DB65E36D0E8D8",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "b5f0604f-0888-43d7-97e0-53b331d891fb",
                          name: "first-name",
                          displayName: "First Name",
                          parentId: "59cdd628-9c31-4a03-b612-acbcddf6ee59",
                          fields: {
                            "Default Value": { value: "" },
                            "Max Length": { value: "255" },
                            "Min Length": { value: "1" },
                            "Placeholder Text": { value: "First name" },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: { value: "0" },
                                key: { value: "zero" },
                              },
                            },
                            "Css Class": { value: "inline" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "f20d5651-f7b9-49a8-9e57-0a3c7e0b5cb8",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/firstname",
                              fields: {
                                value: { value: "firstName" },
                                key: { value: "firstName" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [
                              {
                                id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                fields: {
                                  Message: {
                                    value:
                                      "{0} must have at least {1} and no more than {2} characters.",
                                  },
                                  Parameters: { value: "" },
                                  Type: {
                                    value:
                                      "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                  },
                                },
                              },
                            ],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "4ee89ea7-cefe-4c8e-8532-467ef64591fc",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/single-line-text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/text_field.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: {
                                        value:
                                          "{0} must have at least {1} and no more than {2} characters.",
                                      },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/SingleLineText",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "57CE7E7216534F4F9033E231AD69AFE0",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "fef06ef5-acf7-4373-a8d1-a978e0bf8a43",
                          name: "last-name",
                          displayName: "Last Name",
                          parentId: "59cdd628-9c31-4a03-b612-acbcddf6ee59",
                          fields: {
                            "Default Value": { value: "" },
                            "Max Length": { value: "255" },
                            "Min Length": { value: "1" },
                            "Placeholder Text": { value: "Last name" },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: { value: "0" },
                                key: { value: "zero" },
                              },
                            },
                            "Css Class": { value: "inline" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "ceb2b470-c127-4eda-b777-0d5943f0c90a",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/lastname",
                              fields: {
                                value: { value: "lastName" },
                                key: { value: "lastName" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [
                              {
                                id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                fields: {
                                  Message: {
                                    value:
                                      "{0} must have at least {1} and no more than {2} characters.",
                                  },
                                  Parameters: { value: "" },
                                  Type: {
                                    value:
                                      "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                  },
                                },
                              },
                            ],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "4ee89ea7-cefe-4c8e-8532-467ef64591fc",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/single-line-text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/text_field.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: {
                                        value:
                                          "{0} must have at least {1} and no more than {2} characters.",
                                      },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/SingleLineText",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "EF0F512D39CE4F759715B4680BF02EF5",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "9902964f-a12d-4f3f-a954-31eb13980c16",
                          name: "nameButtonNextClick",
                          displayName: "Next Page",
                          parentId: "59cdd628-9c31-4a03-b612-acbcddf6ee59",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "Next" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "3AD1E5279740470796028C7203617EB0",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "91b9df2f-26a8-42cf-8ab4-12433ad46ccb",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "9902964f-a12d-4f3f-a954-31eb13980c16",
                              fields: {
                                Description: { value: "Email" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{F4F6D69A-B0EE-448E-A918-DE572F13E071}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Redirect to page failed!",
                                    },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "f4f6d69a-b0ee-448e-a918-de572f13e071",
                      name: "emailPage",
                      displayName: "Email",
                      parentId: "67232667-4c94-4762-9f36-d07f7a5fc6e7",
                      fields: {
                        gaLabel: { value: "" },
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        "Css Class": { value: "emailPage" },
                        isHidden: { value: false },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationLoadingText: { value: "" },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "A822D936CE184893B07F20E4B97E9B22",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "5e63c75b-326f-425b-b13c-e0d35c6ccd51",
                          name: "Text",
                          displayName: "Text",
                          parentId: "f4f6d69a-b0ee-448e-a918-de572f13e071",
                          fields: {
                            "Html Tag": { value: "h5" },
                            Text: { value: "My email is" },
                            "Css Class": { value: "inline" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "97A7E3EA18774D5EBD50D8D73064CD99",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "2a8bfc65-47b9-4d38-a03c-f170043e7878",
                          name: "Email",
                          displayName: "Email",
                          parentId: "f4f6d69a-b0ee-448e-a918-de572f13e071",
                          fields: {
                            "Default Value": { value: "" },
                            "Max Length": { value: "255" },
                            "Min Length": { value: "0" },
                            "Placeholder Text": { value: "abc@xyz.com" },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: { value: "0" },
                                key: { value: "zero" },
                              },
                            },
                            "Css Class": { value: "inline" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "fa36b97a-b013-41b6-b33a-b8c3e2843137",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/email",
                              fields: {
                                value: { value: "email" },
                                key: { value: "email" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [
                              {
                                id: "9bae3e9a-d89f-4f93-9577-68b5e9d44a38",
                                fields: {
                                  Message: { value: "Invalid email address." },
                                  Parameters: {
                                    value:
                                      "/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]/",
                                  },
                                  Type: {
                                    value:
                                      "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms",
                                  },
                                },
                              },
                            ],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "04c39cac-8976-4910-be0d-879ed3368429",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/email",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: { value: "OfficeWhite/32x32/mail.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "886adec1-abf8-40e1-9926-d9189c4e8e1b",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/email",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "9bae3e9a-d89f-4f93-9577-68b5e9d44a38",
                                    fields: {
                                      Message: {
                                        value: "Invalid email address.",
                                      },
                                      Parameters: {
                                        value:
                                          "/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]/",
                                      },
                                      Type: {
                                        value:
                                          "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms",
                                      },
                                    },
                                  },
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: {
                                        value:
                                          "{0} must have at least {1} and no more than {2} characters.",
                                      },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    " FWD.Foundation.Forms.CustomSingleLineViewModel, FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Email" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "CF485B1F33E5435281D931A3DD5B328B",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "b0c9436d-dded-4276-b991-802f72a0e446",
                          name: "emailNextClick",
                          displayName: "Next Page",
                          parentId: "f4f6d69a-b0ee-448e-a918-de572f13e071",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "Next" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "7BB73BAD1EEC4F309AB7046C2FFF2ED2",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "7bef61ea-2b04-4eb9-b93e-a0fff767cb86",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "b0c9436d-dded-4276-b991-802f72a0e446",
                              fields: {
                                Description: { value: "Phone Number" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{D8ECAC52-C61C-45B4-88F3-22BA305760EC}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Redirect to page failed!",
                                    },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "d8ecac52-c61c-45b4-88f3-22ba305760ec",
                      name: "phonePage",
                      displayName: "Phone Number",
                      parentId: "67232667-4c94-4762-9f36-d07f7a5fc6e7",
                      fields: {
                        gaLabel: { value: "" },
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        "Css Class": { value: "phonePage" },
                        isHidden: { value: false },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationLoadingText: { value: "" },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "9D55C171FC094F128842ACE2B3DDA4A9",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "97cb3d11-e6e5-4601-87ad-84c09217c682",
                          name: "Text",
                          displayName: "Text",
                          parentId: "d8ecac52-c61c-45b4-88f3-22ba305760ec",
                          fields: {
                            "Html Tag": { value: "h5" },
                            Text: { value: "My phone number is" },
                            "Css Class": { value: "inline" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "68525ADA341A44E4A149A8B8DFECA243",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "64272b8e-172d-4181-9c79-e01c8be2532f",
                          name: "country_code",
                          displayName: "Country Code",
                          parentId: "d8ecac52-c61c-45b4-88f3-22ba305760ec",
                          fields: {
                            "Default Value": { value: "+852" },
                            "Max Length": { value: "255" },
                            "Min Length": { value: "0" },
                            "Placeholder Text": { value: "" },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: { value: "0" },
                                key: { value: "zero" },
                              },
                            },
                            "Css Class": {
                              value: "inline disabled countryCodeInput",
                            },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "01b8756b-4bc7-4534-b990-516943821261",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/countrycode",
                              fields: {
                                value: { value: "countryCode" },
                                key: { value: "countryCode" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "4ee89ea7-cefe-4c8e-8532-467ef64591fc",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/single-line-text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/text_field.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: {
                                        value:
                                          "{0} must have at least {1} and no more than {2} characters.",
                                      },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/SingleLineText",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "8964ED2ED7E64233BBB0708A7872ABD8",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "e397fcb9-49f6-4b0c-ac1c-f8d5e4dba0fb",
                          name: "Telephone",
                          displayName: "Telephone",
                          parentId: "d8ecac52-c61c-45b4-88f3-22ba305760ec",
                          fields: {
                            "Default Value": { value: "" },
                            "Max Length": { value: "8" },
                            "Min Length": { value: "8" },
                            "Placeholder Text": { value: "00000000" },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: { value: "0" },
                                key: { value: "zero" },
                              },
                            },
                            "Css Class": { value: "inline telephoneInput" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: {
                              value: "Please input an 8-digit phone number",
                            },
                            apiName: {
                              id: "22259656-b6e9-4f74-993e-4578dbcf0741",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/cellphone",
                              fields: {
                                value: { value: "cellPhone" },
                                key: { value: "cellPhone" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [
                              {
                                id: "e61ea5ab-77bb-4278-9b13-eac1c30e8e0e",
                                fields: {
                                  Message: {
                                    value:
                                      "Please input an 8-digit phone number",
                                  },
                                  Parameters: { value: "/\\d{2}\\s?\\d{6}$/" },
                                  Type: {
                                    value:
                                      "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms",
                                  },
                                },
                              },
                            ],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "df74f55b-47e6-4d1c-92f8-b0d46a7b2704",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/telephone",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/mobile_phone.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "1aa74652-2177-48c9-88f5-1214445fea34",
                                    fields: {
                                      Message: {
                                        value:
                                          "Please input 9 to 10 digits phone number.",
                                      },
                                      Parameters: { value: "//^d +$//" },
                                      Type: {
                                        value:
                                          "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms",
                                      },
                                    },
                                  },
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: {
                                        value:
                                          "{0} must have at least {1} and no more than {2} characters.",
                                      },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Telephone",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "17D41C11355B4567AF0A9A0E1C21E415",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "a7324495-834e-4952-9f5f-8ed87667ec10",
                          name: "phoneNextClick",
                          displayName: "Phone Next Page",
                          parentId: "d8ecac52-c61c-45b4-88f3-22ba305760ec",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "Next" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "0D2F27C755FB4C2DA0D53F6A1178BBAD",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "1bae53be-b4f4-440c-bee2-17e160806b2e",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "a7324495-834e-4952-9f5f-8ed87667ec10",
                              fields: {
                                Description: { value: "Time Details" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{3B4CB499-4D21-48AC-AEEB-8C593DA796E2}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Redirect to page failed!",
                                    },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "3b4cb499-4d21-48ac-aeeb-8c593da796e2",
                      name: "timePage",
                      displayName: "Time Details",
                      parentId: "67232667-4c94-4762-9f36-d07f7a5fc6e7",
                      fields: {
                        gaLabel: { value: "" },
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        "Css Class": { value: "timePage" },
                        isHidden: { value: false },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationLoadingText: { value: "" },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "F46A6A39786642D2A743E145F488033A",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "9169e6f7-63ed-43fd-a08d-ecb5c46115d4",
                          name: "Text",
                          displayName: "Text",
                          parentId: "3b4cb499-4d21-48ac-aeeb-8c593da796e2",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "I'm available to chat at" },
                            "Css Class": { value: "inline" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "1F077668016D44FB84DED130859AFD6D",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "63d7513a-0fdc-4760-b025-e4ad47b34d36",
                          name: "timeDropdown",
                          displayName: "timeDropdown",
                          parentId: "3b4cb499-4d21-48ac-aeeb-8c593da796e2",
                          fields: {
                            "Show Empty Item": { value: true },
                            isAutoSuggest: { value: false },
                            isDynamicDropdown: { value: false },
                            node: { value: "" },
                            Datasource: {
                              id: "58f59e4e-2486-42c4-8ed7-0663f6709b55",
                              fieldType: "Droptree",
                              fieldName: "Datasource",
                              url: "/content/forms/contacttimelist",
                              fields: {},
                            },
                            "Default Selection": { value: "" },
                            "Display Field Name": { value: "value" },
                            "Is Dynamic": { value: true },
                            "Value Field Name": { value: "key" },
                            "Css Class": { value: "inline" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "1e985703-c4e7-402d-a310-c17b2d90d381",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/preferredtime",
                              fields: {
                                value: { value: "preferredTime" },
                                key: { value: "preferredTime" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "Select time" },
                            Required: { value: true },
                            Validations: [],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Collapsed by Default": { value: false },
                            "Field Type": {
                              id: "e0cfadee-1ac0-471d-a820-2e70d1547b4b",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/lists/dropdown-list",
                              fields: {
                                BackgroundColor: { value: "Grass" },
                                Icon: {
                                  value: "OfficeWhite/32x32/drop_down_list.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "9121d435-48b8-4649-9d13-03d680474fad",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/dropdownlist",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomDropDownListViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/DropdownList",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "3769A8E2F8484912B8012DBDCD9A47CA",
                            },
                          },
                          items: [
                            {
                              id: "e8276918-4b19-479f-bf99-812073dd26e2",
                              name: "Anytime",
                              displayName: "Anytime",
                              parentId: "58f59e4e-2486-42c4-8ed7-0663f6709b55",
                              fields: {
                                value: { value: "Anytime" },
                                key: { value: "1" },
                              },
                            },
                            {
                              id: "3f8e1d48-91e3-4b9e-aee8-ac0298640733",
                              name: "Morning",
                              displayName: "Morning",
                              parentId: "58f59e4e-2486-42c4-8ed7-0663f6709b55",
                              fields: {
                                value: { value: "Morning" },
                                key: { value: "2" },
                              },
                            },
                            {
                              id: "acfd5752-51e9-47c7-8076-dc7535941906",
                              name: "Afternoon",
                              displayName: "Afternoon",
                              parentId: "58f59e4e-2486-42c4-8ed7-0663f6709b55",
                              fields: {
                                value: { value: "Afternoon" },
                                key: { value: "3" },
                              },
                            },
                            {
                              id: "4e60ba21-687c-4d8e-8b04-142cae2d85c7",
                              name: "Evening",
                              displayName: "Evening",
                              parentId: "58f59e4e-2486-42c4-8ed7-0663f6709b55",
                              fields: {
                                value: { value: "Evening" },
                                key: { value: "4" },
                              },
                            },
                          ],
                        },
                        {
                          id: "2023c795-54ff-4d3b-876d-55e1d001e583",
                          name: "ToolTip",
                          displayName: "ToolTip",
                          parentId: "3b4cb499-4d21-48ac-aeeb-8c593da796e2",
                          fields: {
                            toolTipText: {
                              value:
                                "We will contact you based on your preference.",
                            },
                            label: { value: "Why are you asking this" },
                            "Css Class": { value: "tool-tip" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Is Tracking Enabled": { value: true },
                            "Field Type": {
                              id: "fff6a7f6-db43-49f4-80aa-519af8ede3c5",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/tooltip",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: { value: "Office/32x32/question.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "1edd4140-c0f7-4b64-aaf6-dd99abd590de",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/tooltip",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomToolTipViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/ToolTip",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "29ED9249AB9443A7AE544758CCAA7313",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "590269d5-bbb6-491d-806d-481f0a391182",
                          name: "ConsentSection",
                          displayName: "ConsentSection",
                          parentId: "3b4cb499-4d21-48ac-aeeb-8c593da796e2",
                          fields: {
                            backgroundColor: {
                              id: "cf8cf9a4-0f70-4db2-b298-90e820aca94b",
                              fieldType: "Droplink",
                              fieldName: "backgroundColor",
                              url: "/sitecore/content/fwd/global/settings/list/colors/greywhite",
                              fields: {
                                value: { value: "grey-white" },
                                key: { value: "grey-white" },
                              },
                            },
                            "Css Class": { value: "consentSection" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "447aa745-6d29-4b65-a5a3-8173aa8af548",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/section",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: {
                                  value:
                                    "OfficeWhite/32x32/document_header.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "8cddb194-f456-4a75-89b7-346f8f39f95c",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/section",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "Sitecore.ExperienceForms.Mvc.Models.Fields.FieldViewModel,Sitecore.ExperienceForms.Mvc",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Section",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "D1DB62D5FEC444C2A45286CD26178BF9",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "60ba5856-cd35-4344-942d-502f2f678295",
                              name: "privacyPolicy",
                              displayName: "privacyPolicy",
                              parentId: "590269d5-bbb6-491d-806d-481f0a391182",
                              fields: {
                                Datasource: {
                                  id: "6972a94e-4114-4ddc-b610-c76d2f5e0aa2",
                                  fieldType: "Droptree",
                                  fieldName: "Datasource",
                                  url: "/content/forms/product-enquiry-privacy-policy",
                                  fields: {},
                                },
                                "Default Selection": {
                                  value:
                                    "{0B9BD9FA-6439-496C-8400-978BFFE515A2}",
                                },
                                "Display Field Name": { value: "value" },
                                "Is Dynamic": { value: true },
                                "Value Field Name": { value: "value" },
                                "Css Class": {
                                  value: "block privacyPolicyCheckbox",
                                },
                                isHidden: { value: false },
                                HelpText: { value: "" },
                                GeneralError: { value: "" },
                                SpecificError: { value: "" },
                                apiName: {
                                  id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                                  fieldType: "Droplink",
                                  fieldName: "apiName",
                                  url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                                  fields: {
                                    value: { value: "" },
                                    key: { value: "" },
                                  },
                                },
                                serverValidationErrorText: { value: "" },
                                enableServerValidation: { value: false },
                                serverValidationLoadingText: { value: "" },
                                serverValidationAPI: null,
                                "Label Css Class": { value: "" },
                                Title: { value: "" },
                                Required: { value: false },
                                Validations: [],
                                "Is Tracking Enabled": { value: true },
                                "Allow Save": { value: true },
                                "Value Provider Parameters": { value: "" },
                                "Value Provider": null,
                                "Field Type": {
                                  id: "d86a361a-d4ff-46b2-9e97-a37fc5b1fe1a",
                                  fieldType: "Droptree",
                                  fieldName: "Field Type",
                                  url: "/sitecore/system/settings/forms/field-types/lists/checkbox-list",
                                  fields: {
                                    BackgroundColor: { value: "Grass" },
                                    Icon: {
                                      value:
                                        "OfficeWhite/32x32/checkbox_group.png",
                                    },
                                    IsDisabled: { value: false },
                                    SpritePosition: { value: "" },
                                    "Field Template": {
                                      id: "5b672865-55d2-413e-b699-fdfc7e732ccf",
                                      fieldType: "Droptree",
                                      fieldName: "Field Template",
                                      url: "/sitecore/templates/system/forms/fields/list",
                                      fields: {},
                                    },
                                    "Allowed Validations": [],
                                    "Model Type": {
                                      value:
                                        "FWD.Foundation.Forms.CustomCheckBoxListViewModel,FWD.Foundation.Forms",
                                    },
                                    "Property Editor": null,
                                    "View Path": {
                                      value: "FieldTemplates/CheckBoxList",
                                    },
                                  },
                                },
                                Conditions: { value: '{"fieldConditions":[]}' },
                                "Field Key": {
                                  value: "C470CC60AF974C7AADFF19FFAF9BF37D",
                                },
                                "Collapsed by Default": { value: false },
                              },
                              items: [
                                {
                                  id: "0b9bd9fa-6439-496c-8400-978bffe515a2",
                                  name: "product enquiry privacy-policy",
                                  displayName: "Product Enquiry Privacy Policy",
                                  parentId:
                                    "6972a94e-4114-4ddc-b610-c76d2f5e0aa2",
                                  fields: {
                                    value: {
                                      value:
                                        'Disclaimer: The features above are indicative only and does not contain the full terms and benefits of the Policy, key product risks and major exclusions. For details, please refer to the Product Brochure. For explanation of the terms and conditions, please call our Customer Engagement Hotline at +852 3123 3123 during office hours at 09:00-23:00 Monday to Sunday.<br />\n<br />\nBy submitting this form,\n<ul>\n    <li>I have read and understood <a rel="noopener noreferrer" href="http://" target="_blank">the Personal Information Collection Statement</a><a rel="noopener noreferrer" href="http://" target="_blank">&nbsp;</a>and agree to be bounded by it.</li>\n    <li>I understand that my personal data collected by FWD Life Insurance Company (Bermuda) Limited (incorporated in Bermuda with limited liability) will be used to provide further services in relation to this form.</li>\n</ul>',
                                    },
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          id: "7055a4d5-4b5d-4ec7-a36b-f34f2d882ba9",
                          name: "phoneSubmitClick",
                          displayName: "Phone Submit",
                          parentId: "3b4cb499-4d21-48ac-aeeb-8c593da796e2",
                          fields: {
                            "Navigation Step": { value: "0" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "submitButton" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "Submit" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "1BCD51427EDA4A908AD768C2D9CA67CF",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "7b9e2027-125e-45d6-abd1-5cfaef0011a1",
                              name: "Send Email",
                              displayName: "Send Email",
                              parentId: "7055a4d5-4b5d-4ec7-a36b-f34f2d882ba9",
                              fields: {
                                Description: { value: "" },
                                Parameters: { value: "" },
                                "Submit Action": {
                                  id: "2f66e378-be9d-4d9d-b43b-fc6ddc0e3db5",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/custom-action",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Saving form data failed!",
                                    },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.SaveData",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                            {
                              id: "9e333088-052f-496d-ae6c-c8ff5dc08dc3",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "7055a4d5-4b5d-4ec7-a36b-f34f2d882ba9",
                              fields: {
                                Description: { value: "Thank You - Phone" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{BD6AE5DF-DB1F-4A31-9F95-9F2633B3BB0C}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Redirect to page failed!",
                                    },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "bd6ae5df-db1f-4a31-9f95-9f2633b3bb0c",
                      name: "phoneEnquiryThankYouPage",
                      displayName: "Thank You - Phone",
                      parentId: "67232667-4c94-4762-9f36-d07f7a5fc6e7",
                      fields: {
                        gaLabel: { value: "" },
                        backgroundColor: {
                          id: "b47928d6-98fc-4b29-8d0f-586ab477286e",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/orangewhite",
                          fields: {
                            value: { value: "orange-white" },
                            key: { value: "OrangeWhite" },
                          },
                        },
                        "Css Class": {
                          value: "phoneSubmitPage darkMode conditionPage",
                        },
                        isHidden: { value: false },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationLoadingText: { value: "" },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "F880144362CB4E118C0EE581A4C3D11C",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "963b3962-3620-4d40-ac83-62529f95cfd8",
                          name: "Text",
                          displayName: "Text",
                          parentId: "bd6ae5df-db1f-4a31-9f95-9f2633b3bb0c",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "Thank You" },
                            "Css Class": { value: "" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "753703DC08564AD893AFA873A6215A42",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "271dce0d-5d4a-49ac-810f-e19bb20a67f5",
                          name: "Text",
                          displayName: "Text",
                          parentId: "bd6ae5df-db1f-4a31-9f95-9f2633b3bb0c",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: {
                              value:
                                "Our representative will call you at your preferred time shortly.",
                            },
                            "Css Class": { value: "" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "AD687F01371E4675ACA08600A3624030",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "843244ed-0fbc-4618-9b58-8274019d4000",
                          name: "MediaSource",
                          displayName: "MediaSource",
                          parentId: "bd6ae5df-db1f-4a31-9f95-9f2633b3bb0c",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "Text" },
                            "Css Class": { value: "" },
                            isHidden: { value: true },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "9966e4e3-f61b-48f4-9958-8eedf4aa3665",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/mediasource",
                              fields: {
                                value: { value: "mediaSource" },
                                key: { value: "mediaSource" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "3DA1A3628894402E9BE4E5BC3B57C06A",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "aceae7c7-d88a-4cd8-9dd1-419678a08aa1",
                          name: "backToHome",
                          displayName: "Back to Home",
                          parentId: "bd6ae5df-db1f-4a31-9f95-9f2633b3bb0c",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "back-to-home" },
                            isHidden: { value: false },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationLoadingText: { value: "" },
                            serverValidationAPI: null,
                            "Label Css Class": { value: "" },
                            Title: { value: "Back to page" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "1B48EED990F64B8DBA5887B6BCFC9DC5",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            "jss-footer": [],
          },
        },
      },
    },
  },
};
